import { FormikProvider, useFormik, Form, ErrorMessage, FieldArray, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Table, Row, Col, Button, Modal } from "react-bootstrap";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { BsEyeFill, BsFileEarmarkPdfFill } from "react-icons/bs";
import { generateDeficienciesPdf } from "../../PdfGenerate";
import { AllowFloats } from "../../CommonUtils/CommonValidations";
import { CollegeReport } from "./CollegeReport";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { viewImage } from "../../CommonUtils/viewImage";
import FirstLevelInspPreviewForShiftingPreview from "./FirstLevelInspPreviewForShiftingPreview";

//priyanka
export default function ShiftingScrutinyReport({ collCode, nocType, instName }) {
    const login = sessionStorage.getItem("user_id");
    const secondPhaseInspForShifting = login.startsWith("noc_")
    const CllgCodeFromSession = login.split("_")[1] || "";
    const [apiValues, setApiValues] = useState({});
    const [pgCourses, setPgCourses] = useState([]);
    const [corpusFundInstall, setcorpusFundInstall] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [ugCorpusFunds, setUgCorpusFunds] = useState([]);
    const [pgCorpusFunds, setPgCorpusFunds] = useState([]);
    const [getPGBEFORE, setPGBEFORE] = useState([]);
    const [getUgCourses, setUgCourse] = useState([]);
    const [getAccomidation, setAccom] = useState([])
    const [getDef, setDef] = useState([])
    const [showInspectionPreviewModal, setShowInspectionPreviewModal] = useState(false);
    const finalStatusOptions = secondPhaseInspForShifting
        ? [
            { value: "May be permitted", label: "May be permitted" },
            { value: "May not be permitted", label: "May not be permitted" },
            { value: "Conditionally Permitted", label: "Conditionally Permitted" },
        ]
        : [
            { value: "DeficiencyIdentified", label: "Deficiencies Identified" },
            { value: "NoDeficienciesIdentified", label: "No Deficiencies Identified" },
        ];

    useEffect(() => {
        getShiftingScrutinyDetails();
        getShiftingAddDetails();
        finalGetAfterSubmit();
    }, []);
    const handleSave = async () => {
        const finalStatusSelected = formik.values.finalStatus && formik.values.finalStatus.trim() !== "";
        if (finalStatusSelected) {
            // const errors = await formik.validateForm();
            // if (Object.keys(errors).length > 0) {
            //     Swal.fire({
            //         icon: "warning",
            //         title: "Cannot Save with Final Status",
            //         html: `You have selected a <strong>Final Status</strong> but some required fields are missing.<br/><br/>
            //             To save as a <strong>draft</strong>, please clear the Final Status selection.<br/>
            //             Or fill all required fields before saving with Final Status.`,
            //         confirmButtonColor: "#d33",
            //         confirmButtonText: "OK"
            //     });
            //     return;
            // }
        }
        submitShiftingScrutiny(formik.values, "save");
    };
    const [shiftAddr, setShiftAddr] = useState([])
    function getShiftingAddDetails() {
        const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${collCode || CllgCodeFromSession}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status === true) {
                    const shiftData = Array.isArray(res?.data?.data) ? res.data.data : [];
                    setShiftAddr(shiftData?.length > 0 && shiftData !== "No data found" ? shiftData : []);
                    if (shiftData.length > 0) {
                        const firstShift = shiftData[0];
                        setShiftAddr({
                            new_mandal: firstShift.mandal_name || firstShift.new_mandal,
                            new_district: firstShift.new_dist || firstShift.new_district,
                            new_pincode: firstShift.new_pincode,
                            address_ofnew_location: firstShift.address_ofnew_location,
                            shift_type: firstShift.shift_type,
                            distance_from_existing: firstShift.distance_from_existing,
                            justification: firstShift.justification,
                            // shift_type: firstShift.shift_type,
                            lease_from_date: firstShift.lease_from_date,
                            lease_to_date: firstShift.lease_to_date
                        });
                    }
                } else {
                    setShiftAddr([]);
                }
            })
            .catch((err) => {
                setShiftAddr([]);
            });
    }
    const [leasedData, setLeasedData] = useState([])
    const leasedDataFnc = async () => {
        const collCodeToUse = collCode || CllgCodeFromSession;
        let url = config.url.FAC_URL + "getleasedtls/" + collCodeToUse;
        try {
            const res = await CommonAxiosGet(url);
            if (res && res.data.status === true) {
                setLeasedData(res?.data?.leasedtls[0] || res?.data?.leasedtls || []);
            } else {
                setLeasedData([]);
            }
        } catch (err) {
            console.error("Error fetching leased data:", err);
            setLeasedData([]);
        }
    };
    useEffect(() => {
        getSurveyNumberr();
        leasedDataFnc();
    }, [])
    const [getSurvey, setSurvey] = useState([]);
    const getSurveyNumberr = async () => {
        const collCodeToUse = collCode || CllgCodeFromSession;
        let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCodeToUse;
        try {
            const res = await CommonAxiosGet(url);
            if (res && res.data.status === true) {
                setSurvey(res?.data?.data[0] || res.data.data || []);
            } else {
                setSurvey([]);
            }
        } catch (err) {
            console.error("Error fetching survey number:", err);
            setSurvey([]);
        }
    };

    function getShiftingScrutinyDetails() {
        const code = collCode || CllgCodeFromSession;

        let url = config.url.FAC_URL + `getScrutinyDetails/${code}/${nocType || "shifting"}`;

        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    setApiValues(res?.data.data?.[0] || {});
                    setUgCourse(res?.data?.ugCourses || []);
                    setcorpusFundInstall(
                        Array.isArray(res?.data?.corpusFundInstall)
                            ? res.data.corpusFundInstall
                            : []
                    );
                    setPgCourses(res?.data?.pgCourses || []);
                    const buildArea = res?.data?.buildArea || [];
                    const ugData = buildArea.filter((item) => item.build_block_name === "UG BLOCK");
                    const pgData = buildArea.filter((item) => item.build_block_name === "PG BLOCK");
                    const corpusData = res?.data?.corpusfundUGPG || [];
                    const safeData = Array.isArray(corpusData) ? corpusData : [];
                    const ugFunds = safeData.filter(
                        (item) => item.coll_type?.replace(/"/g, "").trim() === "UG"
                    );
                    const pgBeforeFunds = safeData.filter(
                        (item) => item.coll_type?.replace(/"/g, "").trim() === "PG before"
                    );
                    const pgAfterFunds = safeData.filter(
                        (item) => item.coll_type?.replace(/"/g, "").trim() === "PG after"
                    );
                    setUgCorpusFunds(ugFunds);
                    setPGBEFORE(pgBeforeFunds);
                    setPgCorpusFunds(pgAfterFunds);
                } else {
                    setApiValues({});
                }
            })

    }
    
    const getInstallmentData = (installmentNo) => {
        const installment = corpusFundInstall?.find((item) => item?.installment_no === installmentNo);
        return installment || {};
    };
    const validationSchema = Yup.object({
        infrastructure: Yup.object().shape({
            principalRoom: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Principal Room photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            officeRoom: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Office Room photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            staffRoom: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Staff Room photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            classrooms: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                classroom1: Yup.object().shape({
                    filePath: Yup.string().when("selected", {
                        is: "yes",
                        then: (schema) => schema.required("Please upload Classroom 1 photo"),
                        otherwise: (schema) => schema.notRequired()
                    })
                }),
                classroom2: Yup.object().shape({
                    filePath: Yup.string().when("selected", {
                        is: "yes",
                        then: (schema) => schema.required("Please upload Classroom 2 photo"),
                        otherwise: (schema) => schema.notRequired()
                    })
                }),
                classroom3: Yup.object().shape({
                    filePath: Yup.string().when("selected", {
                        is: "yes",
                        then: (schema) => schema.required("Please upload Classroom 3 photo"),
                        otherwise: (schema) => schema.notRequired()
                    })
                })
            }),
            laboratories: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Laboratory photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            library: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Library photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            playGround: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Play Ground photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            parking: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Parking photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            toilets: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Toilets photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            fireSafety: Yup.object().shape({
                selected: Yup.string().when([], {
                    is: () => secondPhaseInspForShifting,
                    then: (schema) => schema.required("Please select Yes or No"),
                    otherwise: (schema) => schema.notRequired()
                }),
                filePath: Yup.string().when("selected", {
                    is: "yes",
                    then: (schema) => schema.required("Please upload Fire Safety Equipment photograph"),
                    otherwise: (schema) => schema.notRequired()
                })
            }),
            videoUpload: Yup.object().shape({
                videoUrl: Yup.string().nullable()
            })
        }), // No validation when Phase 2 is not active
        societyResolution: Yup.string().required("Required"),
        // socityForShiftingRemarks: Yup.string().required("Required"),
        socityRegistered: Yup.string().required("Required"),
        // registrationActRemarks: Yup.string().required("Required"),
        byeLaws: Yup.string().required("Required"),
        // byLawsRemarks: Yup.string().required("Required"),
        permissionOrder: Yup.string().required("Required"),
        // enclosedOrNotRemarks: Yup.string().required("Required"),
        universityAffOrder: Yup.string().required("Required"),
        // atestUniversityRemarks: Yup.string().required("Required"),
        lastEop: Yup.string().required("Required"),
        // eopGrantedRemarks: Yup.string().required("Required"),
        landDeedProduced: Yup.string().required("Required"),
        // ownershipOfTheRemarks: Yup.string().required("Required"),
        landOwnedDoc: Yup.string().required("Required"),
        // ownedNameRemarks: Yup.string().required("Required"),
        natureOfShifting: Yup.string().required("Required"),
        // natureOfShiftingRemarks: Yup.string().required("Required"),
        withinSameMandal: Yup.string().required("Required"),
        // proposedToBeShiftedRemarks: Yup.string().required("Required"),
        permanentBuilding: Yup.string().required("Required"),
        // buildingIsPermanentRemarks: Yup.string().required("Required"),
        distanceFromNuisance: Yup.string().required("Required"),
        // located500MtrsRemarks: Yup.string().required("Required"),
        // buildingType: Yup.string().required("Required"),
        // buildingIsLeasedRemarks: Yup.string().required("Required"),
        buildingPlanApproved: Yup.string().required("Required"),
        // buildingAccommodationApprovedRemarks: Yup.string().required("Required"),
        planLicensedSurveyor: Yup.string().required("Required"),
        // drawnByLicensedRemarks: Yup.string().required("Required"),
        constructionPermission: Yup.string().required("Required"),
        // constructionPermissionRemarks: Yup.string().required("Required"),
        sanitaryCertificate: Yup.string().required("Required"),
        // sanitaryErtificateRemarks: Yup.string().required("Required"),
        geotaggedPhotos: Yup.string().required("Required"),
        // geotaggedPhotographsRemarks: Yup.string().required("Required"),
        otherInstitution: Yup.string().required("Required"),
        // isNstitutionRunningRemarks: Yup.string().required("Required"),
        matchAnnexure: Yup.string().required("Required"),
        // existingBuildingRemarks: Yup.string().required("Required"),
        // playgroundSamePremises: Yup.string().required("Required"),
        // fireSafety: Yup.string().required("Required"),
        corpusFund: Yup.string().required("Required"),
        // corpusFundRemarks: Yup.string().required("Required"),
        certificateIssued: Yup.string().when("corpusFund", {
            is: "Yes",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // certificateIssuedRemarks: Yup.string().when("corpusFund", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        infraLabEquipment: Yup.string().required("Required"),
        // infraLabEquipmentRemarks: Yup.string().required("Required"),
        infraLabLackEquipment: Yup.string().when("infraLabEquipment", {
            is: "No",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // infraLabLackEquipmentRemarks: Yup.string().when("infraLabEquipment", {
        //     is: "No",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        infraLibraryBooksProvided: Yup.string().required("Required"),
        // infraLibraryBooksProvidedRemarks: Yup.string().required("Required"),
        infraLibraryLackBooks: Yup.string().when("infraLibraryBooksProvided", {
            is: "No",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // infraLibraryLackBooksRemarks: Yup.string().when("infraLibraryBooksProvided", {
        //     is: "No",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        infraStaffRunClg: Yup.string().required("Required"),
        // infraStaffAdequateRemarks: Yup.string().required("Required"),
        infraStaffDeficiencies: Yup.string().when("infraStaffRunClg", {
            is: "No",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // infraStaffDeficienciesRemarks: Yup.string().when("infraStaffRunClg", {
        //     is: "No",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        infraStaffScholarshipDetails: Yup.string().required("Required"),
        // infraScholarshipDetailsRemarks: Yup.string().required("Required"),
        infraStaffUniversityRanks: Yup.string().required("Required"),
        // infraUniversityRanksRemarks: Yup.string().required("Required"),
        infraStaffConductedExtension: Yup.string().required("Required"),
        // infraExtensionActivitiesRemarks: Yup.string().required("Required"),
        infraStaffFunctionalWebsite: Yup.string().required("Required"),
        // infraFunctionalWebsiteRemarks: Yup.string().required("Required"),
        finalRemarks: Yup.string().required("Final remarks are required").min(10, "Minimum 10 characters"),
        finalStatus: Yup.string().required("Required"),
        signedInspectionReport: Yup.string().when("finalStatus", {
            is: (val) => secondPhaseInspForShifting && !!val,
            then: (schema) => schema.required("Please upload signed inspection report"),
            otherwise: (schema) => schema.notRequired(),
        }),
        deficiencies: Yup.array().when("finalStatus", {
            is: (val) => {
                if (secondPhaseInspForShifting) {
                    return val === "May not be permitted" || val === "Conditionally Permitted";
                }
                return val === "DeficiencyIdentified";
            },
            then: (schema) =>
                schema
                    .of(
                        Yup.object().shape({
                            remarks: Yup.string()
                                .required("Deficiency remarks are required")
                                .min(5, "Please enter at least 5 characters")
                                .max(500, "Remarks cannot exceed 500 characters"),
                        })
                    )
                    .min(1, "At least one deficiency is required")
                    .required("Deficiencies are required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // deficiencies: Yup.array().when("finalStatus", {
        //     is: "DeficiencyIdentified",
        //     then: (schema) => schema
        //         .of(
        //             Yup.object().shape({
        //                 // remarks: Yup.string()
        //                 //     .required("Deficiency remarks are required")
        //                 //     .min(5, "Please enter at least 5 characters")
        //                 //     .max(500, "Remarks cannot exceed 500 characters")
        //             })
        //         )
        //         .min(1, "At least one deficiency is required")
        //         .required("Deficiencies are required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        accomodation: Yup.array()
            .of(
                Yup.object({
                    sufficientAsPerNorms: Yup.string().required('Please select Yes/No'),
                    // remarks: Yup.string().required('Remarks are required')
                })
            )
            .when([], {
                is: (val) => val && val.length > 0,
                then: (schema) => schema.min(1, 'Accommodation data is required'),
                otherwise: (schema) => schema.notRequired()
            }),
        parkingAvailable: Yup.string().required("Please select parking availability"),
        // parkingAvailableRemarks: Yup.string().required("Required"),
        societyOwnLand: Yup.string().required("Please select parking availability"),
        // societyOwnLandRemarks: Yup.string().required("Required"),
        parkingWithin100Meters: Yup.string().when("parkingAvailable", {
            is: "No",
            then: (schema) => schema.required("Please select this option"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // parkingWithin100metersRemarks: Yup.string().when("parkingAvailable", {
        //     is: "No",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        parkingAreaWithin100mDocUploaded: Yup.string().when("parkingWithin100Meters", {
            is: "Yes",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // finalRemarksRemarks: Yup.string().when("parkingWithin100Meters", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        // parkingArea20Percent: Yup.string().required("Please select this option"),
        parkingArea20Percent: Yup.string().when("parkingAvailable", {
            is: "Yes",
            then: (schema) => schema.required("Please select this option"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // parkingArea20percentRemarks: Yup.string().when("parkingAvailable", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        playgroundAvailable: Yup.string().required("Please select playground availability"),
        // playgroundAvailableRemarks: Yup.string().required("Required"),
        playgroundExtent: Yup.string().when("playgroundAvailable", {
            is: "Yes",
            then: (schema) => schema.required("Please enter playground extent"),
            otherwise: (schema) => schema.notRequired()
        }),
        // playgroundExtentRemarks: Yup.string().when("playgroundAvailable", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired()
        // }),
        alternativePlayground: Yup.string().when("playgroundAvailable", {
            is: "No",
            then: (schema) => schema.required("Please select this option"),
            otherwise: (schema) => schema.notRequired()
        }),
        // alternativeArrangementRemarks: Yup.string().when("playgroundAvailable", {
        //     is: "No",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired()
        // }),
        playgroundMoU: Yup.string().when("alternativePlayground", {
            is: "Yes",
            then: (schema) => schema.required("Please select MoU status"),
            otherwise: (schema) => schema.notRequired()
        }),
        // playgroundMouRemarks: Yup.string().when("alternativePlayground", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired()
        // }),
        parkingExemptedCases: Yup.string().required("Please select fire safety certificate status"),
        // parkingExemptedCasesRemarks: Yup.string().required("Required"),
        latestAffidavit: Yup.string().required("Required"),
        // latestAffidavitRemarks: Yup.string().required("Required"),
        scheduleTallying: Yup.string().required("Required"),
        // sketchPlanRemarks: Yup.string().required("Required"),
        sketchPlanProduced: Yup.string().required("Required"),
        // licensedSurveyorRemarks: Yup.string().required("Required"),
        landDistanceFromCllg: Yup.string().required("Required"),
        // landDistanceRemarks: Yup.string().required("Required"),
        sameMandalLand: Yup.string().required("Required"),
        // sameMandalRemarks: Yup.string().required("Required"),
        plinthArea: Yup.string().required("Required"),
        // plinthAreaRemarks: Yup.string().required("Required"),
        leaseDocEnclosed: Yup.string().when("buildingType", {
            is: "Leased",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // leaseDocEnclosedRemarks: Yup.string().when("buildingType", {
        //     is: "Leased",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        leaseInSocietyName: Yup.string().when("buildingType", {
            is: "Leased",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // leaseInSocietyNameRemarks: Yup.string().when("buildingType", {
        //     is: "Leased",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        saleDeedUploaded: Yup.string().when("buildingType", {
            is: "Own",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // saleDeedUploadedRemarks: Yup.string().when("buildingType", {
        //     is: "Own",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        saleDeedSocietyName: Yup.string().when("buildingType", {
            is: "Own",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // saleDeedSocietyNameRemarks: Yup.string().when("buildingType", {
        //     is: "Own",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        nocProduced: Yup.string().when("otherInstitution", {
            is: "Yes",
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // authorityToUtilizeRemarks: Yup.string().when("otherInstitution", {
        //     is: "Yes",
        //     then: (schema) => schema.required("Required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),

    });
    const formik = useFormik({
        initialValues: {
            societyResolution: "",
            socityForShiftingRemarks: "",
            socityRegistered: "",
            registrationActRemarks: "",
            byeLaws: "",
            byLawsRemarks: "",
            permissionOrder: "",
            enclosedOrNotRemarks: "",
            universityAffOrder: "",
            atestUniversityRemarks: "",
            lastEop: "",
            eopGrantedRemarks: "",
            landDeedProduced: "",
            ownershipOfTheRemarks: "",
            landOwnedDoc: "",
            ownedNameRemarks: "",
            sameMandalLand: "",
            sameMandalRemarks: "",
            sketchPlanProduced: "",
            licensedSurveyorRemarks: "",
            scheduleTallying: "",
            sketchPlanRemarks: "",
            natureOfShifting: "",
            natureOfShiftingRemarks: "",
            withinSameMandal: "",
            proposedToBeShiftedRemarks: "",
            permanentBuilding: "",
            buildingIsPermanentRemarks: "",
            distanceFromNuisance: "",
            located500MtrsRemarks: "",
            buildingType: "",
            buildingIsLeasedRemarks: "",
            leaseDocEnclosed: "",
            leaseDocEnclosedRemarks: "",
            leaseInSocietyName: "",
            leaseInSocietyNameRemarks: "",
            saleDeedUploaded: "",
            saleDeedUploadedRemarks: "",
            saleDeedSocietyName: "",
            saleDeedSocietyNameRemarks: "",
            buildingPlanApproved: "",
            buildingAccommodationApprovedRemarks: "",
            planLicensedSurveyor: "",
            drawnByLicensedRemarks: "",
            constructionPermission: "",
            constructionPermissionRemarks: "",
            sanitaryCertificate: "",
            sanitaryErtificateRemarks: "",
            geotaggedPhotos: "",
            geotaggedPhotographsRemarks: "",
            otherInstitution: "",
            isNstitutionRunningRemarks: "",
            nocProduced: "",
            authorityToUtilizeRemarks: "",
            matchAnnexure: "",
            existingBuildingRemarks: "",
            fireSafety: "",
            fireSafetyCertificateRemarks: "",
            corpusFund: "",
            corpusFundRemarks: "",
            certificateIssued: "",
            certificateIssuedRemarks: "",
            infraLabEquipment: "",
            infraLabEquipmentRemarks: "",
            infraLabLackEquipment: "",
            infraLabLackEquipmentRemarks: "",
            infraLibraryBooksProvided: "",
            infraLibraryBooksProvidedRemarks: "",
            infraLibraryLackBooks: "",
            infraLibraryLackBooksRemarks: "",
            infraStaffRunClg: "",
            infraStaffAdequateRemarks: "",
            infraStaffDeficiencies: "",
            infraStaffDeficienciesRemarks: "",
            infraStaffScholarshipDetails: "",
            infraScholarshipDetailsRemarks: "",
            infraStaffUniversityRanks: "",
            infraUniversityRanksRemarks: "",
            infraStaffConductedExtension: "",
            infraExtensionActivitiesRemarks: "",
            infraStaffFunctionalWebsite: "",
            infraFunctionalWebsiteRemarks: "",
            finalRemarks: "",
            finalStatus: "",
            processingFee: "",
            processingFeeRemarks: "",
            establishment: "",
            establishmentRemarks: "",
            affiliationOrder202526: "",
            affiliationOrder202526Remarks: "",
            society: "",
            societyRemarks: "",
            land: "",
            landRemarks: "",
            building: "",
            buildingRemarks: "",
            sanitary: "",
            sanitaryRemarks: "",
            parking: "",
            parkingRemarks: "",
            playground: "",
            playgroundRemarks: "",
            fireSafetyDef: "",
            fireSafetyRemarks: "",
            corpusFundValue: "",
            corpusFundExtraRemarks: "",
            otherDeficiencies: "",
            otherDeficienciesRemarks: "",
            deficiencies: [{ remarks: "" }],
            accomodation: [],
            societyOwnLand: "",
            societyOwnLandRemarks: "",
            landDistanceFromCllg: "",
            landDistanceRemarks: "",
            parkingAvailable: "",
            parkingAvailableRemarks: "",
            parkingWithin100Meters: "",
            parkingWithin100metersRemarks: "",
            parkingAreaWithin100mDocUploaded: "",
            finalRemarksRemarks: "",
            parkingArea20Percent: "",
            parkingArea20percentRemarks: "",
            playgroundAvailable: "",
            playgroundAvailableRemarks: "",
            playgroundExtent: "",
            playgroundExtentRemarks: "",
            alternativePlayground: "",
            alternativeArrangementRemarks: "",
            playgroundMoU: "",
            playgroundMouRemarks: "",
            parkingExemptedCases: "",
            parkingExemptedCasesRemarks: "",
            latestAffidavit: "",
            latestAffidavitRemarks: "",
            plinthArea: "",
            plinthAreaRemarks: "",
            signedInspectionReport: "",
            infrastructure: {
                principalRoom: { selected: "", file: null },
                officeRoom: { selected: "", file: null },
                staffRoom: { selected: "", file: null },
                // classrooms: { selected: "", file: null, files: [] },
                classrooms: {
                    selected: "",
                    classroom1: { filePath: "", fileName: "" },
                    classroom2: { filePath: "", fileName: "" },
                    classroom3: { filePath: "", fileName: "" }
                },
                // laboratories: { selected: "", file: null, files: [] },
                // laboratories: { selected: "", filePaths: [], fileNames: [] },
                laboratories: { selected: "", filePath: "", fileName: "" },
                library: { selected: "", file: null },
                playGround: { selected: "", file: null },
                parking: { selected: "", file: null },
                toilets: { selected: "", file: null },
                fireSafety: { selected: "", file: null },
                videoUpload: { videoUrl: "" }
            }
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            submitShiftingScrutiny(values);
        },
        validateOnChange: true,
        validateOnBlur: true,
    });
    const firstInstallment = getInstallmentData(1);
    const secondInstallment = getInstallmentData(2);
    const thirdInstallment = getInstallmentData(3);


    // Function to parse documents from API and set infrastructure
    const parseDocumentsToInfrastructure = (documents) => {
        if (!documents || !Array.isArray(documents) || documents.length === 0) return null;

        const infraData = {};

        documents.forEach(doc => {
            const docType = doc.doc_type;
            const docNorms = doc.doc_norms;
            const docUpload = doc.doc_upload;

            switch (docType) {
                case "Principal Room":
                    infraData.principalRoom = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Office Room":
                    infraData.officeRoom = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Staff Room":
                    infraData.staffRoom = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Classroom 1":
                    if (!infraData.classrooms) {
                        infraData.classrooms = { selected: "no", classroom1: {}, classroom2: {}, classroom3: {} };
                    }
                    infraData.classrooms.classroom1 = { filePath: docUpload || "", fileName: "" };
                    infraData.classrooms.selected = docNorms === "Yes" ? "yes" : "no";
                    break;
                case "Classroom 2":
                    if (!infraData.classrooms) {
                        infraData.classrooms = { selected: "no", classroom1: {}, classroom2: {}, classroom3: {} };
                    }
                    infraData.classrooms.classroom2 = { filePath: docUpload || "", fileName: "" };
                    infraData.classrooms.selected = docNorms === "Yes" ? "yes" : "no";
                    break;
                case "Classroom 3":
                    if (!infraData.classrooms) {
                        infraData.classrooms = { selected: "no", classroom1: {}, classroom2: {}, classroom3: {} };
                    }
                    infraData.classrooms.classroom3 = { filePath: docUpload || "", fileName: "" };
                    infraData.classrooms.selected = docNorms === "Yes" ? "yes" : "no";
                    break;
                case "Laboratories":
                    infraData.laboratories = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Library":
                    infraData.library = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Play Ground":
                    infraData.playGround = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Parking":
                    infraData.parking = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Toilets for Men & Women":
                    infraData.toilets = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Fire Safety Equipment":
                    infraData.fireSafety = {
                        selected: docNorms === "Yes" ? "yes" : "no",
                        filePath: docUpload || "",
                        fileName: ""
                    };
                    break;
                case "Video Upload":
                    infraData.videoUpload = {
                        videoUrl: docUpload || ""
                    };
                    break;
                default:
                    break;
            }
        });

        return Object.keys(infraData).length > 0 ? infraData : null;
    };
    function submitShiftingScrutiny(values, mode = "submit") {
        // if (mode === "submit") {

        //     const errors = await formik.validateForm();

        //     const hasErrors = Object.keys(errors).length > 0;

        //     if (mode === "submit" && hasErrors) {

        //         Swal.fire({
        //             icon: "warning",
        //             title: "Please fill all required fields"
        //         });

        //         return;
        //     }
        // }




        Swal.fire({
            title: "Are you sure?",
            text: mode === "save" ? "Do you want to save the draft?" : "Do you want to submit?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: mode === "save" ? "Yes, Save Draft" : "Yes, Submit",
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    collCode: parseInt(collCode, 10) || parseInt(CllgCodeFromSession, 10),
                    plinthArea: values.plinthArea,
                    plinthAreaRemarks: values.plinthAreaRemarks || "",
                    socityForShifting: values.societyResolution,
                    socityForShiftingRemarks: values.socityForShiftingRemarks || "",
                    registrationAct: values.socityRegistered,
                    registrationActRemarks: values.registrationActRemarks || "",
                    byLaws: values.byeLaws,
                    byLawsRemarks: values.byLawsRemarks || "",
                    enclosedOrNot: values.permissionOrder,
                    enclosedOrNotRemarks: values.enclosedOrNotRemarks || "",
                    atestUniversity: values.universityAffOrder,
                    atestUniversityRemarks: values.atestUniversityRemarks || "",
                    eopGranted: values.lastEop,
                    eopGrantedRemarks: values.eopGrantedRemarks || "",
                    ownershipOfThe: values.landDeedProduced,
                    ownershipOfTheRemarks: values.ownershipOfTheRemarks || "",
                    ownedName: values.landOwnedDoc,
                    ownedNameRemarks: values.ownedNameRemarks || "",
                    sameMandal: values.sameMandalLand,
                    sameMandalRemarks: values.sameMandalRemarks || "",
                    licensedSurveyor: values.sketchPlanProduced,
                    licensedSurveyorRemarks: values.licensedSurveyorRemarks || "",
                    sketchPlan: values.scheduleTallying,
                    sketchPlanRemarks: values.sketchPlanRemarks || "",
                    natureOfShifting: values.natureOfShifting,
                    natureOfShiftingRemarks: values.natureOfShiftingRemarks || "",
                    proposedToBeShifted: values.withinSameMandal,
                    proposedToBeShiftedRemarks: values.proposedToBeShiftedRemarks || "",
                    buildingIsPermanent: values.permanentBuilding,
                    buildingIsPermanentRemarks: values.buildingIsPermanentRemarks || "",
                    located500Mtrs: values.distanceFromNuisance,
                    located500MtrsRemarks: values.located500MtrsRemarks || "",
                    buildingIsLeased: values.buildingType || shiftAddr.shift_type || "",
                    buildingIsLeasedRemarks: values.buildingIsLeasedRemarks || "",
                    buildingAccommodationApproved: values.buildingPlanApproved,
                    buildingAccommodationApprovedRemarks: values.buildingAccommodationApprovedRemarks || "",
                    drawnByLicensed: values.planLicensedSurveyor,
                    drawnByLicensedRemarks: values.drawnByLicensedRemarks || "",
                    constructionPermission: values.constructionPermission,
                    constructionPermissionRemarks: values.constructionPermissionRemarks || "",
                    sanitaryErtificate: values.sanitaryCertificate,
                    sanitaryErtificateRemarks: values.sanitaryErtificateRemarks || "",
                    geotaggedPhotographs: values.geotaggedPhotos,
                    geotaggedPhotographsRemarks: values.geotaggedPhotographsRemarks || "",
                    isNstitutionRunning: values.otherInstitution,
                    isNstitutionRunningRemarks: values.isNstitutionRunningRemarks || "",
                    authorityToUtilize: values.nocProduced,
                    authorityToUtilizeRemarks: values.authorityToUtilizeRemarks || "",
                    existingBuilding: values.matchAnnexure,
                    existingBuildingRemarks: values.existingBuildingRemarks || "",
                    playgroundFacility: values.playgroundSamePremises,
                    playgroundFacilityRemarks: values.playgroundFacilityRemarks || "",
                    // alternativeArrangement: values.alternativePlayground,
                    alternativeArrangementRemarks: values.alternativeArrangementRemarks || "",
                    fireSafetyCertificate: values.fireSafety,
                    fireSafetyCertificateRemarks: values.fireSafetyCertificateRemarks || "",
                    corpusFund: values.corpusFund,
                    corpusFundRemarks: values.corpusFundRemarks || "",
                    labEquipmentProvided: values.infraLabEquipment,
                    labEquipmentProvidedRemarks: values.infraLabEquipmentRemarks || "",
                    libraryBooksProvided: values.infraLibraryBooksProvided,
                    libraryBooksProvidedRemarks: values.infraLibraryBooksProvidedRemarks || "",
                    staffUgcNorms: values.infraStaffRunClg,
                    staffUgcNormsRemarks: values.infraStaffAdequateRemarks || "",
                    staffAsPerAnnexure: values.infraStaffScholarshipDetails,
                    staffAsPerAnnexureRemarks: values.infraScholarshipDetailsRemarks || "",
                    staffUniversityRank: values.infraStaffUniversityRanks,
                    staffUniversityRankRemarks: values.infraUniversityRanksRemarks || "",
                    staffExtensionActivities: values.infraStaffConductedExtension,
                    staffExtensionActivitiesRemarks: values.infraExtensionActivitiesRemarks || "",
                    staffFunctionalWebsite: values.infraStaffFunctionalWebsite,
                    staffFunctionalWebsiteRemarks: values.infraFunctionalWebsiteRemarks || "",
                    finalRemarks: values.finalRemarks,
                    finalStatus: values.finalStatus,
                    parkingAvailable: values.parkingAvailable,
                    parkingAvailableRemarks: values.parkingAvailableRemarks || "",
                    parkingWithin100Meters: values.parkingWithin100Meters,
                    parkingWithin100metersRemarks: values.parkingWithin100metersRemarks || "",
                    parkingAreaWithin100mDocUploaded: values.parkingAreaWithin100mDocUploaded,
                    finalRemarksRemarks: values.finalRemarksRemarks || "",
                    parkingArea20Percent: values.parkingArea20Percent,
                    parkingArea20percentRemarks: values.parkingArea20percentRemarks || "",
                    playgroundAvailable: values.playgroundAvailable,
                    playgroundAvailableRemarks: values.playgroundAvailableRemarks || "",
                    playgroundExtent: values.playgroundExtent,
                    playgroundExtentRemarks: values.playgroundExtentRemarks || "",
                    playgroundMoU: values.playgroundMoU,
                    playgroundMouRemarks: values.playgroundMouRemarks || "",
                    alternativeArrangement: values.alternativePlayground,

                    parkingExemptedCases: values.parkingExemptedCases,
                    parkingExemptedCasesRemarks: values.parkingExemptedCasesRemarks || "",
                    latestAffidavit: values.latestAffidavit,
                    latestAffidavitRemarks: values.latestAffidavitRemarks || "",
                    processingFee: values.processingFee || "",
                    processingFeeRemarks: values.processingFeeRemarks || "",
                    establishment: values.establishment || "",
                    establishmentRemarks: values.establishmentRemarks || "",
                    affiliationOrder202526: values.affiliationOrder202526 || "",
                    affiliationOrder202526Remarks: values.affiliationOrder202526Remarks || "",
                    society: values.society || "",
                    societyRemarks: values.societyRemarks || "",
                    land: values.land || "",
                    landRemarks: values.landRemarks || "",
                    building: values.building || "",
                    buildingRemarks: values.buildingRemarks || "",
                    sanitary: values.sanitary || "",
                    sanitaryRemarks: values.sanitaryRemarks || "",
                    parking: values.parking || "",
                    parkingRemarks: values.parkingRemarks || "",
                    playground: values.playground || "",
                    playgroundRemarks: values.playgroundRemarks || "",
                    fireSafety: values.fireSafetyDef || "",
                    fireSafetyRemarks: values.fireSafetyRemarks || "",
                    corpusFundExtra: values.corpusFundValue || "",
                    corpusFundExtraRemarks: values.corpusFundExtraRemarks || "",
                    otherDeficiencies: values.otherDeficiencies || "",
                    otherDeficienciesRemarks: values.otherDeficienciesRemarks || "",
                    saleDeedSocietyName: values.saleDeedSocietyName || "",
                    saleDeedSocietyNameRemarks: values.saleDeedSocietyNameRemarks || "",
                    saleDeedUploaded: values.saleDeedUploaded || "",
                    saleDeedUploadedRemarks: values.saleDeedUploadedRemarks || "",
                    leaseDocEnclosed: values.leaseDocEnclosed || "",
                    leaseDocEnclosedRemarks: values.leaseDocEnclosedRemarks || "",
                    leaseInSocietyName: values.leaseInSocietyName || "",
                    leaseInSocietyNameRemarks: values.leaseInSocietyNameRemarks || "",
                    labLackEquipments: values.infraLabLackEquipment || "",
                    labLackEquipmentsRemarks: values.infraLabLackEquipmentRemarks || "",
                    libraryLackEquipments: values.infraLibraryLackBooks || "",
                    libraryLackEquipmentsRemarks: values.infraLibraryLackBooksRemarks || "",
                    staffTeachingDeficiencies: values.infraStaffDeficiencies || "",
                    staffTeachingDeficienciesRemarks: values.infraStaffDeficienciesRemarks || "",
                    infraStaffScholarshipDetails: values.infraStaffScholarshipDetails || "",
                    infraStaffScholarshipDetailsRemarks: values.infraScholarshipDetailsRemarks || "",
                    certificateIssued: values.certificateIssued || "",
                    certificateIssuedRemarks: values.certificateIssuedRemarks || "",
                    landDistanceFromCllg: values.landDistanceFromCllg || "",
                    landDistanceRemarks: values.landDistanceRemarks || "",
                    isSubmitted: mode === "submit" ? true : false,
                    // CllgCodeFromSession?deficienciesphysicall:deficiencies
                    deficiencies: values.deficiencies || [],
                    deficienciesphysicall: values.deficiencies || [],
                    accomodationphysicall: values.accomodation?.map(item => ({
                        sufficientAsPerNorms: item.sufficientAsPerNorms,
                        remarks: item.remarks,
                        particularName: item.particularName,
                        particularCode: item.particularCode
                    })) || [],
                    accomodation: values.accomodation?.map(item => ({
                        sufficientAsPerNorms: item.sufficientAsPerNorms,
                        remarks: item.remarks,
                        particularName: item.particularName,
                        particularCode: item.particularCode
                    })) || [],
                    societyOwnLand: values.societyOwnLand || "",
                    societyOwnLandRemarks: values.societyOwnLandRemarks || "",
                    signedInspectionReport: values.signedInspectionReport || "",

                    documnets: [
                        { key: "principalRoom", label: "Principal Room", type: "single" },
                        { key: "officeRoom", label: "Office Room", type: "single" },
                        { key: "staffRoom", label: "Staff Room", type: "single" },
                        { key: "classrooms", label: "Classroom 1", subKey: "classroom1", type: "classroom" },
                        { key: "classrooms", label: "Classroom 2", subKey: "classroom2", type: "classroom" },
                        { key: "classrooms", label: "Classroom 3", subKey: "classroom3", type: "classroom" },
                        { key: "laboratories", label: "Laboratories", type: "multiple" },
                        { key: "library", label: "Library", type: "single" },
                        { key: "playGround", label: "Play Ground", type: "single" },
                        { key: "parking", label: "Parking", type: "single" },
                        { key: "toilets", label: "Toilets for Men & Women", type: "single" },
                        { key: "fireSafety", label: "Fire Safety Equipment", type: "single" },
                        { key: "videoUpload", label: "Video Upload", type: "video" }
                    ].map(item => {
                        let docNorms = "No";
                        let docUpload = "";

                        if (item.type === "single") {
                            const selected = formik.values.infrastructure?.[item.key]?.selected;
                            docNorms = selected === "yes" ? "Yes" : "No";
                            docUpload = formik.values.infrastructure?.[item.key]?.filePath || "";
                        }
                        else if (item.type === "classroom") {
                            const selected = formik.values.infrastructure?.classrooms?.selected;
                            docNorms = selected === "yes" ? "Yes" : "No";
                            docUpload = formik.values.infrastructure?.classrooms?.[item.subKey]?.filePath || "";
                        }
                        else if (item.type === "multiple") {
                            const selected = values.infrastructure?.laboratories?.selected;
                            docNorms = selected === "yes" ? "Yes" : "No";
                            docUpload = values.infrastructure?.laboratories?.filePath || "";
                        }
                        else if (item.type === "video") {
                            docNorms = formik.values.infrastructure?.videoUpload?.videoUrl ? "Yes" : "No";
                            // docUpload = formik.values.infrastructure?.videoUpload?.videoUrl || "";
                            docUpload = values.infrastructure?.videoUpload?.videoUrl || "";
                        }

                        return {
                            collCode: parseInt(collCode, 10) || parseInt(CllgCodeFromSession, 10),
                            docType: item.label,
                            docNorms: docNorms,
                            docUpload: docUpload
                        };
                    })

                }
                console.log("payload,payload")
                const endPoint = CllgCodeFromSession ? "saveShiftingScrutinyDetailsphysical" : "saveShiftingScrutinyDetails";
                const url = config.url.FAC_URL + endPoint;
                CommonAxiosPost(url, payload)
                    .then((res) => {
                        if (res && res.data.status === true) {
                            if (res.data.scode === "01") {
                                successAlert2(mode === "save" ? " Saved Successfully!" : res.data.sdesc);
                                // successAlert2(res.data.sdesc);
                                finalGetAfterSubmit();
                            } else {
                                failureAlert(res.data.sdesc);
                            }
                        } else {
                            failureAlert("Submission Failed");
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        failureAlert("Something went wrong!");
                    });
            }
        });
    }
    const [finalGet, setFinalGet] = useState([]);
    const [pdfData, setPdfData1] = useState({});
    function finalGetAfterSubmit() {
        const endPoint = CllgCodeFromSession ? `getShiftingScrutinyDetailsphysical/${CllgCodeFromSession}` : `getShiftingScrutinyDetails/${collCode}`;
        const url = `${config.url.FAC_URL}${endPoint}`;
        // let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${login}`;
        // let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
        CommonAxiosGet(url)
            .then((res) => {
                const data = res?.data?.data;
                const accomData = res?.data?.accom || [];
                const defData = res?.data?.def || [];
                const documents = res?.data?.documents || [];
                setPdfData1(res.data);
                // const validDeficiencies = defData?.filter(item =>
                //     item.remarks && item.remarks.trim() !== ""
                // )

                if (!Array.isArray(defData)) {
                    defData = defData ? [defData] : []; // NOSONAR
                }




                const validDeficiencies = Array.isArray(defData)
                    ? defData?.filter(item => item.remarks && item.remarks?.trim() !== "")
                    : [];

                setDef(validDeficiencies);
                if (data && data.length > 0) {
                    const d = data[0];
                    const mappedDeficiencies = defData?.length > 0 ? defData : [{ remarks: "" }];
                    // const mappedAccommodation = accomData?.map((item) => ({
                    //     sufficientAsPerNorms: item.sufficient_as_per_norms || '',
                    //     remarks: item.remarks || '',
                    //     particularName: item.particular_name || '',
                    //     particularCode: item.particular_code || ''
                    // }));

                    const mappedAccommodation = Array.isArray(accomData)
                        ? accomData.map((item) => ({
                            sufficientAsPerNorms: item.sufficient_as_per_norms || '',
                            remarks: item.remarks || '',
                            particularName: item.particular_name || '',
                            particularCode: item.particular_code || ''
                        }))
                        : [];
                    // if (d) {
                    // if (d.is_submitted === true || d.is_submitted === "true") {
                    //     setIsDisabled(true);
                    // } else {
                    //     setIsDisabled(false);

                    // }
                    if (d) {
                        setIsDisabled(d.is_submitted);
                    }
                    // }
                    setFinalGet(data);
                    const mappedValues = {
                        societyResolution: d.socity_for_shifting || "",
                        socityForShiftingRemarks: d.socity_for_shifting_remarks || "",
                        socityRegistered: d.registration_act || "",
                        registrationActRemarks: d.registration_act_remarks || "",
                        byeLaws: d.by_laws || "",
                        byLawsRemarks: d.by_laws_remarks || "",
                        permissionOrder: d.enclosed_or_not || "",
                        enclosedOrNotRemarks: d.enclosed_or_not_remarks || "",
                        universityAffOrder: d.atest_university || "",
                        atestUniversityRemarks: d.atest_university_remarks || "",
                        lastEop: d.eop_granted || "",
                        eopGrantedRemarks: d.eop_granted_remarks || "",
                        plinthArea: d.plinth_area || "",
                        plinthAreaRemarks: d.plinth_area_remarks || "",
                        landDeedProduced: d.ownership_of_the || "",
                        ownershipOfTheRemarks: d.ownership_of_the_remarks || "",
                        landOwnedDoc: d.owned_name || "",
                        ownedNameRemarks: d.owned_name_remarks || "",
                        sameMandalLand: d.same_mandal || "",
                        sameMandalRemarks: d.same_mandal_remarks || "",
                        sketchPlanProduced: d.licensed_surveyor || "",
                        licensedSurveyorRemarks: d.licensed_surveyor_remarks || "",
                        scheduleTallying: d.sketch_plan || "",
                        sketchPlanRemarks: d.sketch_plan_remarks || "",
                        natureOfShifting: d.nature_of_shifting || "",
                        natureOfShiftingRemarks: d.nature_of_shifting_remarks || "",
                        withinSameMandal: d.proposed_to_be_shifted || "",
                        proposedToBeShiftedRemarks: d.proposed_to_be_shifted_remarks || "",
                        permanentBuilding: d.building_is_permanent || "",
                        buildingIsPermanentRemarks: d.building_is_permanent_remarks || "",
                        distanceFromNuisance: d.located_500_mtrs || "",
                        located500MtrsRemarks: d.located_500_mtrs_remarks || "",
                        buildingType: d.building_is_leased || "",
                        buildingIsLeasedRemarks: d.building_is_leased_remarks || "",
                        leaseDocEnclosed: d.lease_doc_enclosed || "",
                        leaseDocEnclosedRemarks: d.lease_doc_enclosed_remarks || "",
                        leaseInSocietyName: d.lease_in_society_name || "",
                        leaseInSocietyNameRemarks: d.lease_in_society_name_remarks || "",
                        saleDeedUploaded: d.sale_deed_uploaded || "",
                        saleDeedUploadedRemarks: d.sale_deed_uploaded_remarks || "",
                        saleDeedSocietyName: d.sale_deed_society_name || "",
                        saleDeedSocietyNameRemarks: d.sale_deed_society_name_remarks || "",
                        buildingPlanApproved: d.building_accommodation_approved || "",
                        buildingAccommodationApprovedRemarks: d.building_accommodation_approved_remarks || "",
                        planLicensedSurveyor: d.drawn_by_licensed || "",
                        drawnByLicensedRemarks: d.drawn_by_licensed_remarks || "",
                        constructionPermission: d.construction_permission || "",
                        constructionPermissionRemarks: d.construction_permission_remarks || "",
                        sanitaryCertificate: d.sanitary_ertificate || "",
                        sanitaryErtificateRemarks: d.sanitary_ertificate_remarks || "",
                        geotaggedPhotos: d.geotagged_photographs || "",
                        geotaggedPhotographsRemarks: d.geotagged_photographs_remarks || "",
                        otherInstitution: d.is_nstitution_running || "",
                        isNstitutionRunningRemarks: d.is_nstitution_running_remarks || "",
                        nocProduced: d.authority_to_utilize || "",
                        authorityToUtilizeRemarks: d.authority_to_utilize_remarks || "",
                        matchAnnexure: d.existing_building || "",
                        existingBuildingRemarks: d.existing_building_remarks || "",
                        playgroundSamePremises: d.playground_facility || "",
                        playgroundFacilityRemarks: d.playground_facility_remarks || "",
                        // alternativePlayground: d.alternativePlayground || "",



                        fireSafety: d.fire_safety_certificate || "",
                        fireSafetyCertificateRemarks: d.fire_safety_certificate_remarks || "",
                        corpusFund: d.corpus_fund || "",
                        corpusFundRemarks: d.corpus_fund_remarks || "",
                        certificateIssued: d.certificate_issued || "",
                        certificateIssuedRemarks: d.certificate_issued_remarks || "",
                        infraLabEquipment: d.lab_equipment_provided || "",
                        infraLabEquipmentRemarks: d.lab_equipment_provided_remarks || "",
                        infraLabLackEquipment: d.lab_lack_equipments || "",
                        infraLabLackEquipmentRemarks: d.lab_lack_equipments_remarks || "",
                        infraLibraryBooksProvided: d.library_books_provided || "",
                        infraLibraryBooksProvidedRemarks: d.library_books_provided_remarks || "",
                        infraLibraryLackBooks: d.library_lack_equipments || "",
                        infraLibraryLackBooksRemarks: d.library_lack_equipments_remarks || "",
                        infraStaffRunClg: d.staff_ugc_norms || "",
                        infraStaffAdequateRemarks: d.staff_ugc_norms_remarks || "",
                        infraStaffDeficiencies: d.staff_teaching_deficiencies || "",
                        infraStaffDeficienciesRemarks: d.staff_teaching_deficiencies_remarks || "",
                        infraStaffScholarshipDetails: d.staff_as_per_annexure,
                        infraScholarshipDetailsRemarks: d.staff_as_per_annexure_remarks || "",
                        infraStaffUniversityRanks: d.staff_university_rank || "",
                        infraUniversityRanksRemarks: d.staff_university_rank_remarks || "",
                        infraStaffConductedExtension: d.staff_extension_activities || "",
                        infraExtensionActivitiesRemarks: d.staff_extension_activities_remarks || "",
                        infraStaffFunctionalWebsite: d.staff_functional_website || "",
                        infraFunctionalWebsiteRemarks: d.staff_functional_website_remarks || "",
                        finalRemarks: d.final_remarks || "",
                        finalStatus: d.final_status || "",
                        processingFee: d.processing_fee || "",
                        processingFeeRemarks: d.processing_fee_remarks || "",
                        establishment: d.establishment || "",
                        establishmentRemarks: d.establishment_remarks || "",
                        affiliationOrder202526: d.affiliation_order_2025_26 || "",
                        affiliationOrder202526Remarks: d.affiliation_order_2025_26_remarks || "",
                        society: d.society || "",
                        societyRemarks: d.society_remarks || "",
                        land: d.land || "",
                        landRemarks: d.land_remarks || "",
                        building: d.building || "",
                        buildingRemarks: d.building_remarks || "",
                        sanitary: d.sanitary || "",
                        sanitaryRemarks: d.sanitary_remarks || "",
                        parking: d.parking || "",
                        parkingRemarks: d.parking_remarks || "",
                        playground: d.playground || "",
                        playgroundRemarks: d.playground_remarks || "",
                        fireSafetyDef: d.fire_safety || "",
                        fireSafetyRemarks: d.fire_safety_remarks || "",
                        corpusFundValue: d.corpus_fund_extra || "",
                        corpusFundExtraRemarks: d.corpus_fund_extra_remarks || "",
                        otherDeficiencies: d.other_deficiencies || "",
                        otherDeficienciesRemarks: d.other_deficiencies_remarks || "",
                        playgroundAvailable: d.playground_available || "",
                        playgroundAvailableRemarks: d.playground_available_remarks || "",
                        parkingWithin100Meters: d.parking_within_100meters || "",
                        parkingWithin100metersRemarks: d.parking_within_100meters_remarks || "",
                        parkingAreaWithin100mDocUploaded: d.parking_area_doc_uploaded || "",
                        finalRemarksRemarks: d.final_remarks_remarks || "",
                        parkingAvailable: d.parking_available || "",
                        parkingAvailableRemarks: d.parking_available_remarks || "",
                        parkingArea20Percent: d.parking_area20percent || "",
                        parkingArea20percentRemarks: d.parking_area20percent_remarks || "",
                        playgroundExtent: d.playground_extent || "",
                        playgroundExtentRemarks: d.playground_extent_remarks || "",
                        // alternativePlayground:d.alternativePlayground||"",
                        playgroundMoU: d.playgroundMoU || d.play_ground_mou || d.playground_mou || "",
                        playgroundMouRemarks: d.playground_mou_remarks || "",
                        alternativePlayground: d.alternative_arrangement || "",
                        alternativeArrangementRemarks: d.alternative_arrangement_remarks || "",
                        parkingExemptedCases: d.parking_exempted_cases || "",
                        parkingExemptedCasesRemarks: d.parking_exempted_cases_remarks || "",
                        latestAffidavit: d.latest_affidavit || "",
                        latestAffidavitRemarks: d.latest_affidavit_remarks || "",
                        landDistanceFromCllg: d.land_distance_from_cllg || d.land_distance || "",
                        landDistanceRemarks: d.land_distance_remarks || "",
                        landOwnedAsPerNorms: d.landOwnedAsPerNorms || "",
                        societyOwnLand: d.society_own_land || "",
                        societyOwnLandRemarks: d.society_own_land_remarks || "",
                        signedInspectionReport: d.signed_inspection_report || "",
                        accomodation: mappedAccommodation,
                        deficiencies: mappedDeficiencies,
                    };
                    if (!mappedValues.buildingType && shiftAddr?.shift_type) {
                        mappedValues.buildingType = shiftAddr.shift_type === "Leased to Leased" ? "Leased" : "Own";
                    }

                    // formik.setValues(mappedValues);
                    const infrastructureFromDocs = parseDocumentsToInfrastructure(documents);
                    if (infrastructureFromDocs) {
                        mappedValues.infrastructure = {
                            ...mappedValues.infrastructure,
                            ...infrastructureFromDocs
                        };
                    }
                    formik.setValues(mappedValues);
                } else {
                    setFinalGet([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching scrutiny details:", error);
                setFinalGet([]);
            });
    }
    useEffect(() => {
        if (finalGet && finalGet.length > 0) {
            const d = finalGet[0];
            setIsDisabled(d.is_submitted === true);
        }
    }, [finalGet]);
    useEffect(() => {
        handleAccomidations();
    }, []);

    const handleDownloadPDF = () => {
        const finalCode = collCode || CllgCodeFromSession
        const endPoint = CllgCodeFromSession ? `getShiftingScrutinyDetailsphysical/${CllgCodeFromSession}` : `getShiftingScrutinyDetails/${collCode}`;
        let url = `${config.url.FAC_URL}${endPoint}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const deficiencyData = res.data.def || [];

                    if (deficiencyData.length > 0) {
                        const rowData = {
                            inst_name: apiValues.inst_name || apiValues.society_name || apiValues.inst_name || "College",
                            coll_code: collCode,
                            noc_type: "shifting",
                            deficiencies: deficiencyData?.map((item) => ({
                                remarks: item.deficiency_description || item.remarks || item.deficiency || ""
                            }))
                        };
                        // Call your PDF generation function
                        generateDeficienciesPdf(rowData);
                    } else {
                        Swal.fire({
                            icon: 'info',
                            title: 'No Deficiencies',
                            text: 'No deficiencies found to download',
                            confirmButtonColor: '#3085d6'
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: 'No Data',
                        text: 'No deficiencies data available',
                        confirmButtonColor: '#3085d6'
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching deficiencies:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch deficiencies. Please try again.',
                    confirmButtonColor: '#d33'
                });
            });
    };

    function handleAccomidations() {
        const finalCode = collCode || CllgCodeFromSession
        let url = `${config.url.FAC_URL}getAccommodationAreaData/${finalCode}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const accomData = res.data.data || [];
                    setAccom(accomData);

                    // ONLY set if formik doesn't have values OR if values are empty
                    if (formik.values.accomodation.length === 0) {
                        const initialAccomData = accomData?.map((item) => ({
                            sufficientAsPerNorms: '',
                            remarks: '',
                            particularName: item.particular_name || '',
                            particularCode: item.particular_code || ""
                        }));
                        formik.setFieldValue('accomodation', initialAccomData);
                    }
                } else {
                    setAccom([]);
                    if (formik.values.accomodation.length === 0) {
                        formik.setFieldValue('accomodation', []);
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching accomidation details:", error);
                setAccom([]);
            });
    }

    const clearDependentFields = (fieldName, value) => {
        switch (fieldName) {
            case "parkingAvailable":
                if (value === "Yes") {
                    formik.setFieldValue("parkingWithin100Meters", "");
                    formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
                }
                if (value === "No") {
                    formik.setFieldValue("parkingArea20Percent", "");
                }
                break;

            case "parkingWithin100Meters":
                if (value === "No") {
                    formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
                }
                break;

            case "playgroundAvailable":
                if (value === "Yes") {
                    formik.setFieldValue("alternativePlayground", "");
                    formik.setFieldValue("playgroundMoU", "");
                }
                if (value === "No") {
                    formik.setFieldValue("playgroundExtent", "");
                }
                break;

            case "alternativePlayground":
                if (value !== "Yes") {
                    formik.setFieldValue("playgroundMoU", "");
                }
                break;

            case "buildingType":
                if (value === "Leased") {
                    formik.setFieldValue("saleDeedUploaded", "");
                    formik.setFieldValue("saleDeedSocietyName", "");
                }
                if (value === "Own") {
                    formik.setFieldValue("leaseDocEnclosed", "");
                    formik.setFieldValue("leaseInSocietyName", "");
                }
                if (value === "") {
                    formik.setFieldValue("leaseDocEnclosed", "");
                    formik.setFieldValue("leaseInSocietyName", "");
                    formik.setFieldValue("saleDeedUploaded", "");
                    formik.setFieldValue("saleDeedSocietyName", "");
                }
                break;

            case "otherInstitution":
                if (value !== "Yes") {
                    formik.setFieldValue("nocProduced", "");
                }
                break;

            case "corpusFund":
                if (value !== "Yes") {
                    formik.setFieldValue("certificateIssued", "");
                }
                break;

            case "infraLabEquipment":
                if (value !== "No") {
                    formik.setFieldValue("infraLabLackEquipment", "");
                    formik.setFieldValue("infraLabLackEquipmentRemarks", "");
                }
                break;

            case "infraLibraryBooksProvided":
                if (value !== "No") {
                    formik.setFieldValue("infraLibraryLackBooks", "");
                    formik.setFieldValue("infraLibraryLackBooksRemarks", "");
                }
                break;

            case "infraStaffRunClg":
                if (value !== "No") {
                    formik.setFieldValue("infraStaffDeficiencies", "");
                    formik.setFieldValue("infraStaffDeficienciesRemarks", "");
                }
                break;

            // case "finalStatus":
            //     if (value !== "DeficiencyIdentified") {
            //         formik.setFieldValue("deficiencies", [{ remarks: "" }]);
            //     }
            //     break;
            case "finalStatus":
                // For second phase, keep deficiencies for specific statuses only
                if (secondPhaseInspForShifting) {
                    if (value !== "May not be permitted" && value !== "Conditionally Permitted") {
                        formik.setFieldValue("deficiencies", [{ remarks: "" }]);
                    }
                } else if (value !== "DeficiencyIdentified") {
                    formik.setFieldValue("deficiencies", [{ remarks: "" }]);
                }
                break;

            default:
                break;
        }
    };
    console.log("Formik Errors:", formik.errors);
    const formatDate = (dateString) => {
        if (!dateString || dateString === "-") return "-";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "-";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const textareaStyle = {
        height: "auto",
        resize: "vertical",
    };
    useEffect(() => {
        const style = document.createElement("style");

        style.innerHTML = `
          textarea.form-control {
              height: auto;
              resize: vertical;
          }
      `;

        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const savedFinalStatus = finalGet?.[0]?.final_status || "";
    const canShowSecondPhasePreview = secondPhaseInspForShifting && !!savedFinalStatus;

    const handleFinalSubmit = async (mode = "submit") => {

        if (secondPhaseInspForShifting && formik.values.finalStatus && !savedFinalStatus) {
            Swal.fire({
                icon: "info",
                title: "Save details first",
                text: "Please first save the details, then open Inspection Preview and upload the e-sign document before Final Submit.",
            });
            return;
        }

        // STEP 1: run Yup/Formik validation
        const errors = await formik.validateForm();

        // STEP 2: check if any errors exist
        const hasErrors = Object.keys(errors).length > 0;

        // STEP 3: if submit mode + errors → stop
        if (mode === "submit" && hasErrors) {

            Swal.fire({
                icon: "warning",
                title: "Please fill all required fields"
            });

            return;
        }

        if (canShowSecondPhasePreview && !formik.values.signedInspectionReport) {
            Swal.fire({
                icon: "warning",
                title: "Signed report required",
                text: "Please download the Inspection Preview, sign it, and upload the signed PDF before final submit.",
            });
            return;
        }

        // STEP 4: proceed to confirmation + API
        submitShiftingScrutiny(formik.values, mode);
    };
    useEffect(() => {
        if (shiftAddr?.shift_type) {
            const val = shiftAddr.shift_type === "Leased to Leased" ? "Leased" : "Own";
            formik.setFieldValue("buildingType", val);
        }
    }, [shiftAddr]);

    return (
        <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
                <h5 className="text-success mb-3">
                    Scrutiny Report for Shifting of  {apiValues.inst_name || instName} ({collCode || CllgCodeFromSession}) for the Academic Year 2026-27
                </h5>
                {/* {CllgCodeFromSession && (

                    < Modal
                        show={showPreviewModal}
                        onHide={() => setShowPreviewModal(false)}
                        size="xl"
                        dialogClassName="modal-90w"
                        scrollable
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Phase 1 Inspection Preview - College Code: {CllgCodeFromSession}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FirstLevelInspPreviewForShiftingPreview
                                collCode={CllgCodeFromSession}
                                nocType={nocType || "shifting"}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )} */}

                <Row className="mb-3">
                    <Col md={4}>
                        <label className="form-label fw-bold">Name of the Society & Address</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            style={{
                                height: 'auto',
                                resize: 'vertical'
                            }}
                            value={apiValues.society_name && apiValues.mandal_name ?
                                `${apiValues.society_name} - ${apiValues.mandal_name}` :
                                apiValues.society_name || apiValues.mandal_name || "Not available"}
                            readOnly
                        />
                    </Col>
                    <Col md={4}>
                        <label className="form-label fw-bold">Name and address of the Existing Degree College</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={apiValues.inst_name || "Not available"}
                            style={{
                                height: 'auto',
                                resize: 'vertical'
                            }}
                            readOnly
                        />
                    </Col>
                    <Col md={4}>
                        <label className="form-label fw-bold">Name & New Address of the Degree College Proposed to Shift</label>
                        <textarea
                            className="form-control"
                            rows="5"
                            style={{
                                height: 'auto',
                                resize: 'vertical'
                            }}
                            value={`Mandal: ${shiftAddr.new_mandal || shiftAddr.mandal_name || "-"}\nDistrict: ${shiftAddr.new_district || "-"}\nPincode: ${shiftAddr.new_pincode || "-"}\nAddress: ${shiftAddr.address_ofnew_location || "-"}`}
                            readOnly

                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Table bordered responsive>
                            <thead className="table-primary text-center">
                                <tr>
                                    <th style={{ width: "5%" }}>S.No</th>
                                    <th style={{ width: "45%" }}>Particulars</th>
                                    <th style={{ width: "20%" }}>Action</th>
                                    <th style={{ width: "30%" }}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">1</td>
                                    <td>Transaction Id of Registration and processing fee paid (Rs 30,000) </td>
                                    <td>{apiValues.transaction_id || "-"}</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td className="text-center">2</td>
                                    <td>Whether a copy of the resolutions of the Society for shifting of the college is uploaded</td>
                                    <td>
                                        <input type="radio" name="societyResolution" value="Yes" checked={formik.values.societyResolution === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="societyResolution" value="No" checked={formik.values.societyResolution === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="societyResolution" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="socityForShiftingRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="socityForShiftingRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 3 */}
                                <tr>
                                    <td className="text-center">3</td>
                                    <td>Whether the Society is registered under societies registration act</td>
                                    <td>
                                        <input type="radio" name="socityRegistered" value="Yes" checked={formik.values.socityRegistered === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="socityRegistered" value="No" checked={formik.values.socityRegistered === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="socityRegistered" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="registrationActRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="registrationActRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 4 */}
                                <tr>
                                    <td className="text-center">4</td>
                                    <td>Whether the Bye-laws of the Society is enclosed</td>
                                    <td>
                                        <input type="radio" name="byeLaws" value="Yes" checked={formik.values.byeLaws === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="byeLaws" value="No" checked={formik.values.byeLaws === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="byeLaws" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="byLawsRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="byLawsRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 5 */}
                                <tr>
                                    <td className="text-center">5</td>
                                    <td>Year of Establishment of the College</td>
                                    <td>{apiValues.year_of_establishment || "-"}</td>
                                    <td>-</td>
                                </tr>

                                {/* Row 6 */}
                                <tr>
                                    <td className="text-center">6</td>
                                    <td>Whether the permission order for the establishment of the college is enclosed or not</td>
                                    <td>
                                        <input type="radio" name="permissionOrder" value="Yes" checked={formik.values.permissionOrder === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="permissionOrder" value="No" checked={formik.values.permissionOrder === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="permissionOrder" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="enclosedOrNotRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="enclosedOrNotRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 7 */}
                                <tr>
                                    <td className="text-center">7</td>
                                    <td>Whether latest University affiliation order (2025-26) is enclosed or not</td>
                                    <td>
                                        <input type="radio" name="universityAffOrder" value="Yes" checked={formik.values.universityAffOrder === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="universityAffOrder" value="No" checked={formik.values.universityAffOrder === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="universityAffOrder" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="atestUniversityRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="atestUniversityRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 8 */}
                                <tr>
                                    <td className="text-center">8</td>
                                    <td>The college is located in</td>
                                    <td> {apiValues.rural_area === "Yes"
                                        ? "Rural/Tribal"
                                        : apiValues.rural_area === "No"
                                            ? "Urban"
                                            : apiValues.rural_area || "-"}</td>
                                    <td>-</td>
                                </tr>

                                {/* Row 9 */}
                                <tr>
                                    <td className="text-center">9</td>
                                    <td>Whether a copy of the last EoP granted is enclosed</td>
                                    <td>
                                        <input type="radio" name="lastEop" value="Yes" checked={formik.values.lastEop === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="lastEop" value="No" checked={formik.values.lastEop === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="lastEop" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="eopGrantedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="eopGrantedRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Land Section Header */}
                                <tr>
                                    <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>10. Land</td>
                                </tr>
                                <tr>
                                    <td className="text-center">a.</td>
                                    <td>Whether the society has own land as per norms</td>
                                    <td>
                                        <div className="radio-group">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="societyOwnLand"
                                                    value="Yes"
                                                    checked={formik.values.societyOwnLand === 'Yes'}
                                                    onChange={formik.handleChange}
                                                    disabled={isDisabled}
                                                />
                                                Yes
                                            </label>
                                            <label style={{ marginLeft: '1rem' }}>
                                                <input
                                                    type="radio"
                                                    name="societyOwnLand"
                                                    value="No"
                                                    checked={formik.values.societyOwnLand === 'No'}
                                                    onChange={formik.handleChange}
                                                    disabled={isDisabled}
                                                />
                                                No
                                            </label>
                                        </div>
                                        <ErrorMessage name="societyOwnLand" component="div" className="text-danger" />

                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="societyOwnLandRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="societyOwnLandRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10b */}
                                <tr>
                                    <td className="text-center">b.</td>
                                    <td>Whether the registered ownership of the land deed is produced</td>
                                    <td>
                                        <input type="radio" name="landDeedProduced" value="Yes" checked={formik.values.landDeedProduced === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="landDeedProduced" value="No" checked={formik.values.landDeedProduced === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="landDeedProduced" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="ownershipOfTheRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="ownershipOfTheRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10c */}
                                <tr>
                                    <td className="text-center">c.</td>
                                    <td>Details of the land owned</td>
                                    <td>
                                        <>
                                            Survey No: {getSurvey.survey_no || "-"}<br />
                                            Village/Town: {getSurvey.village_name || "-"}<br />
                                            Mandal: {getSurvey.mandal_name || "-"}<br />
                                            District: {getSurvey.dist_name || "-"}
                                        </>
                                    </td>
                                    <td>-</td>
                                </tr>

                                {/* Row 10d */}
                                <tr>
                                    <td className="text-center">d.</td>
                                    <td>Whether the registered document of the land owned in the name of the Society</td>
                                    <td>
                                        <input type="radio" name="landOwnedDoc" value="Yes" checked={formik.values.landOwnedDoc === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="landOwnedDoc" value="No" checked={formik.values.landOwnedDoc === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="landOwnedDoc" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="ownedNameRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="ownedNameRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10e */}
                                <tr>
                                    <td className="text-center">e.</td>
                                    <td>Whether the own land is provided in the same Mandal</td>
                                    <td>
                                        <input type="radio" name="sameMandalLand" value="Yes" checked={formik.values.sameMandalLand === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="sameMandalLand" value="No" checked={formik.values.sameMandalLand === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="sameMandalLand" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" style={textareaStyle} name="sameMandalRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="sameMandalRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10f */}
                                <tr>
                                    <td className="text-center">f.</td>
                                    <td>Mention distance of the land from the college building (in km)</td>
                                    <td>
                                        <input
                                            type="text"
                                            name="landDistanceFromCllg"
                                            className="form-control"
                                            value={formik.values.landDistanceFromCllg || ""}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Enter distance in km"
                                            disabled={isDisabled}
                                            onKeyPress={AllowFloats}
                                            maxLength={6}
                                        />
                                        <ErrorMessage name="landDistanceFromCllg" component="div" className="text-danger" />

                                    </td>
                                    <td>
                                        <Field as="textarea" name="landDistanceRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="landDistanceRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10g */}
                                <tr>
                                    <td className="text-center">g.</td>
                                    <td>Whether the sketch plan of own land drawn by the licensed surveyor and attested by the MRO is produced</td>
                                    <td>
                                        <input type="radio" name="sketchPlanProduced" value="Yes" checked={formik.values.sketchPlanProduced === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="sketchPlanProduced" value="No" checked={formik.values.sketchPlanProduced === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="sketchPlanProduced" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="licensedSurveyorRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="licensedSurveyorRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 10h */}
                                <tr>
                                    <td className="text-center">h.</td>
                                    <td>Whether the schedule of property mentioned in the registered ownership deed is tallying with the sketch plan produced</td>
                                    <td>
                                        <input type="radio" name="scheduleTallying" value="Yes" checked={formik.values.scheduleTallying === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="scheduleTallying" value="No" checked={formik.values.scheduleTallying === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="scheduleTallying" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="sketchPlanRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="sketchPlanRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* New Building Accommodation Header */}
                                <tr>
                                    <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>11. New Building Accommodation</td>
                                </tr>

                                {/* Row 11a - NEW: Nature of Shifting dropdown */}
                                <tr>
                                    <td className="text-center">a.</td>
                                    <td>Nature of Shifting</td>
                                    <td>
                                        <select name="natureOfShifting" className="form-select" value={formik.values.natureOfShifting} onChange={formik.handleChange} disabled={isDisabled}>
                                            <option value="">-- Select --</option>
                                            <option value="Leased to leased (up to ten years with less than 30 years lease)">
                                                College age: Under 10 years | Lease: Less than 30 years (EoP required)
                                            </option>
                                            <option value="Leased to leased (up to ten years with 30 years lease)">
                                                College age: Under 10 years | Lease: 30 years
                                            </option>
                                            <option value="Leased to leased (more than ten years with 30 years lease)">
                                                College age: Over 10 years | Lease: 30 years
                                            </option>
                                            <option value="Leased to own building">
                                                Moving from Leased to Own Building
                                            </option>
                                        </select>
                                        <ErrorMessage name="natureOfShifting" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="natureOfShiftingRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="natureOfShiftingRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11b - NEW: Within same Mandal */}
                                <tr>
                                    <td className="text-center">b.</td>
                                    <td>Whether the college is proposed to be shifted within the same Mandal</td>
                                    <td>
                                        <input type="radio" name="withinSameMandal" value="Yes" checked={formik.values.withinSameMandal === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="withinSameMandal" value="No" checked={formik.values.withinSameMandal === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="withinSameMandal" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="proposedToBeShiftedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="proposedToBeShiftedRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11c - NEW: Permanent building with RCC roof */}
                                <tr>
                                    <td className="text-center">c.</td>
                                    <td>Whether the new building is permanent and independent building with RCC roof</td>
                                    <td>
                                        <input type="radio" name="permanentBuilding" value="Yes" checked={formik.values.permanentBuilding === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="permanentBuilding" value="No" checked={formik.values.permanentBuilding === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="permanentBuilding" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="buildingIsPermanentRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="buildingIsPermanentRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11d - NEW: Distance from nuisance */}
                                <tr>
                                    <td className="text-center">d.</td>
                                    <td>Whether it is stated that the college is located at least 500 mtrs far away from Cinema halls, wine shops, public function halls etc. in the application.</td>
                                    <td>
                                        <input type="radio" name="distanceFromNuisance" value="Yes" checked={formik.values.distanceFromNuisance === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="distanceFromNuisance" value="No" checked={formik.values.distanceFromNuisance === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="distanceFromNuisance" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="located500MtrsRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="located500MtrsRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11e - NEW: Building type dropdown */}
                                <tr>
                                    <td className="text-center">e.</td>
                                    <td>State whether the proposed building is leased / own</td>
                                    <td>
                                        <td className="text-center">
                                            <Field
                                                type="text" value={
                                                    shiftAddr.shift_type === "Leased to Leased"
                                                        ? "Leased"
                                                        : shiftAddr.shift_type === "Leased to Own" ? "Own" : shiftAddr.shift_type === "Leased to Own" ? "Own"
                                                            ? "Own"
                                                            : shiftAddr.shift_type === "Own"
                                                            : "Own"

                                                }
                                                disabled
                                            />

                                        </td>
                                        {/* {firstShift.shift_type==="Leased to Leased" ?"Leased":"Own"} */}

                                        {/* <select name="buildingType" className="form-select" value={formik.values.buildingType} onChange={(e) => { formik.handleChange(e); clearDependentFields("buildingType", e.target.value); }} disabled={isDisabled}>
                                            <option value="">-- Select --</option>
                                            <option value="Leased">Leased</option>
                                            <option value="Own">Own</option>
                                        </select>
                                        <ErrorMessage name="buildingType" component="div" className="text-danger" /> */}
                                    </td>
                                    <td>
                                        <Field as="textarea" name="buildingIsLeasedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="buildingIsLeasedRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11f - NEW: Lease document conditional */}
                                {formik.values.buildingType === "Leased" && (
                                    <>
                                        <tr>
                                            <td className="text-center">e1.</td>
                                            <td>If leased, Registered lease document of the building is enclosed</td>
                                            <td>
                                                <input type="radio" name="leaseDocEnclosed" value="Yes" checked={formik.values.leaseDocEnclosed === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="leaseDocEnclosed" value="No" checked={formik.values.leaseDocEnclosed === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="leaseDocEnclosed" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="leaseDocEnclosedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="leaseDocEnclosedRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">e2.</td>
                                            <td>Whether the leased document is registered in the name of the society</td>
                                            <td>
                                                <input type="radio" name="leaseInSocietyName" value="Yes" checked={formik.values.leaseInSocietyName === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="leaseInSocietyName" value="No" checked={formik.values.leaseInSocietyName === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="leaseInSocietyName" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="leaseInSocietyNameRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="leaseInSocietyNameRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">e3.</td>
                                            <td>Year of registration of lease document</td>
                                            <td>{leasedData.year_of_reg || "-"}</td>
                                            <td>-</td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">e4.</td>
                                            <td>Validity of the lease period</td>
                                            {/* <td className="text-center">
                                                {(() => {
                                                    const from = shiftAddr.lease_from_date;
                                                    const to = shiftAddr.lease_to_date;

                                                    if (!from || !to) return "-";

                                                    const fromDate = new Date(from);
                                                    const toDate = new Date(to);

                                                    let years = toDate.getFullYear() - fromDate.getFullYear();

                                                    // Adjust if end date is before anniversary date
                                                    const hasNotCompletedYear =
                                                        toDate.getMonth() < fromDate.getMonth() ||
                                                        (toDate.getMonth() === fromDate.getMonth() &&
                                                            toDate.getDate() < fromDate.getDate());

                                                    if (hasNotCompletedYear) {
                                                        years--;
                                                    }

                                                    return years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "-";
                                                })()}
                                            </td> */}
                                            <td>  {leasedData.validity_lease ? `${leasedData.validity_lease} years` : "-"}</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">e5.</td>
                                            <td>Total no. of years completed in leased building from the establishment</td>
                                            <td>{leasedData.no_years || "-"}</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">e6.</td>
                                            <td>Remaining no. of years of the lease period as on date of the application</td>
                                            <td>{leasedData?.remain_years}</td>
                                            <td>-</td>
                                        </tr>
                                    </>
                                )}

                                {/* Row 11k - NEW: Sale deed for own building */}
                                {console.log("formik.values.buildingType", formik.values.buildingType)}
                                {(formik.values.buildingType === "Own" || formik.values.buildingType == "Own" || shiftAddr.shift_type === "Leased to Own") && (
                                    <>
                                        <tr>
                                            <td className="text-center">e1.</td>
                                            <td>If own, Registered sale deed of the building is uploaded</td>
                                            <td>
                                                <input type="radio" name="saleDeedUploaded" value="Yes" checked={formik.values.saleDeedUploaded === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="saleDeedUploaded" value="No" checked={formik.values.saleDeedUploaded === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="saleDeedUploaded" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="saleDeedUploadedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="saleDeedUploadedRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">e2.</td>
                                            <td>Whether the sale deed is registered in the name of the Society</td>
                                            <td>
                                                <input type="radio" name="saleDeedSocietyName" value="Yes" checked={formik.values.saleDeedSocietyName === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="saleDeedSocietyName" value="No" checked={formik.values.saleDeedSocietyName === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="saleDeedSocietyName" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="saleDeedSocietyNameRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="saleDeedSocietyNameRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                    </>
                                )}

                                {/* Row 11m */}
                                <tr>
                                    <td className="text-center">f.</td>
                                    <td>Whether the plan of the building accommodation is approved by competent authority for running the institution</td>
                                    <td>
                                        <input type="radio" name="buildingPlanApproved" value="Yes" checked={formik.values.buildingPlanApproved === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="buildingPlanApproved" value="No" checked={formik.values.buildingPlanApproved === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="buildingPlanApproved" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="buildingAccommodationApprovedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="buildingAccommodationApprovedRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11n */}
                                <tr>
                                    <td className="text-center">g.</td>
                                    <td>Whether approved plan of the building drawn by licensed surveyor and attested by the Principal of a Government College is uploaded</td>
                                    <td>
                                        <input type="radio" name="planLicensedSurveyor" value="Yes" checked={formik.values.planLicensedSurveyor === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="planLicensedSurveyor" value="No" checked={formik.values.planLicensedSurveyor === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="planLicensedSurveyor" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="drawnByLicensedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="drawnByLicensedRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11o */}
                                {/* <tr>
                                        <td className="text-center">h.</td>
                                        <td>Plinth area of the Building (in Sft)</td>
                                        <td>{apiValues.plinth_area || "-"}</td>
                                    </tr> */}
                                <tr>
                                    <td className="text-center">h.</td>
                                    <td>Plinth area of the Building (in Sft)</td>
                                    <td>
                                        <Field
                                            type="text"
                                            name="plinthArea"
                                            className="form-control"
                                            placeholder="Enter plinth area in Sft"
                                            maxLength={5}
                                            disabled={isDisabled}
                                            onKeyPress={AllowFloats}
                                            value={formik.values.plinthArea || ""}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <ErrorMessage name="plinthArea" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="plinthAreaRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="plinthAreaRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>
                                {/* Row 11p */}
                                <tr>
                                    <td className="text-center">i.</td>
                                    <td>Whether a copy of the construction permission order for the leased / own building issued by competent authority is uploaded</td>
                                    <td>
                                        <input type="radio" name="constructionPermission" value="Yes" checked={formik.values.constructionPermission === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="constructionPermission" value="No" checked={formik.values.constructionPermission === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="constructionPermission" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="constructionPermissionRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="constructionPermissionRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11q */}
                                <tr>
                                    <td className="text-center">j.</td>
                                    <td>Whether valid Sanitary Certificate is uploaded</td>
                                    <td>
                                        <input type="radio" name="sanitaryCertificate" value="Yes" checked={formik.values.sanitaryCertificate === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="sanitaryCertificate" value="No" checked={formik.values.sanitaryCertificate === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="sanitaryCertificate" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="sanitaryErtificateRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="sanitaryErtificateRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11r - NEW: Geotagged photos */}
                                <tr>
                                    <td className="text-center">k.</td>
                                    <td>Whether latest Geotagged photographs of the building attested by the Principal of a Government College are uploaded</td>
                                    <td>
                                        <input type="radio" name="geotaggedPhotos" value="Yes" checked={formik.values.geotaggedPhotos === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="geotaggedPhotos" value="No" checked={formik.values.geotaggedPhotos === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="geotaggedPhotos" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="geotaggedPhotographsRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="geotaggedPhotographsRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11s */}
                                <tr>
                                    <td className="text-center">l.</td>
                                    <td>Whether any other Institution is running in the same building accommodation</td>
                                    <td>
                                        <input type="radio" name="otherInstitution" value="Yes" checked={formik.values.otherInstitution === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("otherInstitution", e.target.value); }} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="otherInstitution" value="No" checked={formik.values.otherInstitution === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("otherInstitution", e.target.value); }} disabled={isDisabled} /> No
                                        <ErrorMessage name="otherInstitution" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="isNstitutionRunningRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="isNstitutionRunningRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>

                                {/* Row 11t - NEW: NoC conditional */}
                                {formik.values.otherInstitution === "Yes" && (
                                    <tr>
                                        <td className="text-center">l1.</td>
                                        <td> whether NoC from the concerned authority to utilize part of the building, which is not being utilized by the other institution, for running this institution is uploaded</td>
                                        <td>
                                            <input type="radio" name="nocProduced" value="Yes" checked={formik.values.nocProduced === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                            <input type="radio" name="nocProduced" value="No" checked={formik.values.nocProduced === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                            <ErrorMessage name="nocProduced" component="div" className="text-danger" />
                                        </td>
                                        <td>
                                            <Field as="textarea" name="authorityToUtilizeRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                            <ErrorMessage name="authorityToUtilizeRemarks" component="div" className="text-danger" />
                                        </td>
                                    </tr>
                                )}

                                {/* Row 11u */}
                                <tr>
                                    <td className="text-center">m.</td>
                                    <td>Whether the details of existing building accommodation provided in Annexure-I are in accordance with the stipulated norms</td>
                                    <td>
                                        <input type="radio" name="matchAnnexure" value="Yes" checked={formik.values.matchAnnexure === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                                        <input type="radio" name="matchAnnexure" value="No" checked={formik.values.matchAnnexure === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                        <ErrorMessage name="matchAnnexure" component="div" className="text-danger" />
                                    </td>
                                    <td>
                                        <Field as="textarea" name="existingBuildingRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                        <ErrorMessage name="existingBuildingRemarks" component="div" className="text-danger" />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>

                        {/* UG Accommodation Table - Same as EoP */}
                        {getAccomidation?.length > 0 && (<>
                            <React.Fragment key={getAccomidation.length}>
                                <h5 className="text-success mb-3">n.Accommodation required & provided for existing PG/UG programmes</h5>
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th>Sl. No.</th>
                                            <th>Type of the room</th>
                                            <th>No. of room(s) required</th>
                                            <th>Total carpet area (sft) required</th>
                                            <th>No. of room(s) provided</th>
                                            <th>Total carpet area (sft) provided</th>
                                            <th>Whether sufficient as per norms</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {getAccomidation?.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{index + 1}</td>

                                                <td>{item.particular_name}</td>

                                                <td>{item.no_of_rooms}</td>
                                                <td>{item.total_area}</td>
                                                <td>{item.no_of_rooms}</td>
                                                <td>{item.total_area}</td>


                                                {/* <td>{"-"}</td> */}
                                                <td>
                                                    <label>
                                                        <input type="radio" name={`accomodation.${index}.sufficientAsPerNorms`} value="Yes" checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "Yes"} onChange={formik.handleChange} disabled={isDisabled} onBlur={formik.handleBlur} /> Yes
                                                    </label>
                                                    <label className="ms-2">
                                                        <input type="radio" name={`accomodation.${index}.sufficientAsPerNorms`} value="No" checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "No"} onChange={formik.handleChange} disabled={isDisabled} onBlur={formik.handleBlur} />No
                                                    </label>
                                                    <ErrorMessage name={`accomodation.${index}.sufficientAsPerNorms`} component="div" className="text-danger" />
                                                </td>

                                                <td>
                                                    <input type="text" className="form-control" name={`accomodation.${index}.remarks`}
                                                        value={formik.values.accomodation?.[index]?.remarks || ''}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        disabled={isDisabled} />
                                                    <ErrorMessage
                                                        name={`accomodation.${index}.remarks`}
                                                        component="div"
                                                        className="text-danger"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </React.Fragment>
                        </>)}
                        <Row>
                            <Col>
                                {/* ========== TABLE 1: PARKING AREA ========== */}
                                <h5 className="text-success mb-3 mt-4">12.Parking area</h5>

                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "5%" }}>Sl. No.</th>
                                            <th style={{ width: "45%" }}>Particulars</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                            <th style={{ width: "30%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>Whether the parking area is available in the same premises</td>
                                            <td>
                                                <input type="radio" name="parkingAvailable" value="Yes" checked={formik.values.parkingAvailable === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingAvailable", e.target.value); }} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="parkingAvailable" value="No" checked={formik.values.parkingAvailable === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingAvailable", e.target.value); }} disabled={isDisabled} /> No
                                                <ErrorMessage name="parkingAvailable" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="parkingAvailableRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="parkingAvailableRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        {formik.values.parkingAvailable === "No" && (
                                            <tr>
                                                <td className="text-center">a.1</td>
                                                <td>
                                                    If not in the same premises, whether the parking area provided
                                                    within a distance of 100 meters thereof
                                                </td>
                                                <td>
                                                    <input
                                                        type="radio"
                                                        name="parkingWithin100Meters"
                                                        value="Yes"
                                                        checked={formik.values.parkingWithin100Meters === "Yes"}
                                                        onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingWithin100Meters", e.target.value); }}
                                                        disabled={isDisabled}
                                                    /> Yes &nbsp;

                                                    <input
                                                        type="radio"
                                                        name="parkingWithin100Meters"
                                                        value="No"
                                                        checked={formik.values.parkingWithin100Meters === "No"}
                                                        onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingWithin100Meters", e.target.value); }}
                                                        disabled={isDisabled}
                                                    /> No

                                                    <ErrorMessage
                                                        name="parkingWithin100Meters"
                                                        component="div"
                                                        className="text-danger"
                                                    />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="parkingWithin100metersRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="parkingWithin100metersRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}
                                        {/* a.2 */}
                                        {formik.values.parkingAvailable === "No" && formik.values.parkingWithin100Meters === "Yes" && (
                                            <tr>
                                                <td className="text-center">a.2</td>
                                                <td>Whether the document is uploaded for proof of parking area with in 100 meters</td>
                                                <td >
                                                    <label>
                                                        <Field type="radio" name="parkingAreaWithin100mDocUploaded" value="Yes" disabled={isDisabled} /> Yes
                                                    </label>
                                                    <label className="ms-3">
                                                        <Field type="radio" name="parkingAreaWithin100mDocUploaded" value="No" disabled={isDisabled} /> No
                                                    </label>
                                                    <ErrorMessage name="parkingAreaWithin100mDocUploaded" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="finalRemarksRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="finalRemarksRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}
                                        {formik.values.parkingAvailable === "Yes" && (<tr>
                                            <td className="text-center">b.</td>
                                            <td>Whether 20% of the total built up area is provided for the Parking area</td>
                                            <td onBlur={() => {
                                                formik.setFieldTouched("parkingArea20Percent", true);
                                            }}>
                                                <Field type="radio" name="parkingArea20Percent" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                                                <Field type="radio" name="parkingArea20Percent" value="No" disabled={isDisabled} /> No
                                                <ErrorMessage name="parkingArea20Percent" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="parkingArea20percentRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="parkingArea20percentRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>)}


                                    </tbody>
                                </Table>

                                {/* Playground Table - Separate Table */}
                                <h5 className="text-success mb-3 mt-4">13.Playground</h5>
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "5%" }}>Sl. No.</th>
                                            <th style={{ width: "45%" }}>Particulars</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                            <th style={{ width: "30%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>Whether the Playground facility is available in the same premises</td>
                                            <td>
                                                <input type="radio" name="playgroundAvailable" value="Yes" checked={formik.values.playgroundAvailable === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("playgroundAvailable", e.target.value); }} disabled={isDisabled} /> Yes &nbsp;
                                                <input type="radio" name="playgroundAvailable" value="No" checked={formik.values.playgroundAvailable === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("playgroundAvailable", e.target.value); }} disabled={isDisabled} /> No
                                                <ErrorMessage name="playgroundAvailable" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="playgroundAvailableRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="playgroundAvailableRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        {formik.values.playgroundAvailable === "Yes" && (
                                            <tr>
                                                <td className="text-center">a.1</td>
                                                <td>mention the extent of the playground facility available (sft)</td>
                                                <td>
                                                    <Field type="text" name="playgroundExtent" className="form-control" placeholder="Enter extent in sft" disabled={isDisabled}
                                                        onKeyPress={(e) => {
                                                            const key = e.key;
                                                            const value = e.target.value;
                                                            if (key === 'Backspace' || key === 'Delete' || key === 'Tab' || key === 'Enter' || key === 'ArrowLeft' || key === 'ArrowRight') {
                                                                return;
                                                            }
                                                            if (!/[0-9.]/.test(key)) {
                                                                e.preventDefault();
                                                            }
                                                            if (key === '.' && value.includes('.')) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/[^0-9.]/g, '');
                                                            const parts = value.split('.');
                                                            if (parts.length > 2) {
                                                                value = parts[0] + '.' + parts.slice(1).join('');
                                                            }
                                                            formik.setFieldValue('playgroundExtent', value);
                                                        }}
                                                    />
                                                    <ErrorMessage name="playgroundExtent" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="playgroundExtentRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="playgroundExtentRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}
                                        {formik.values.playgroundAvailable === "No" && (
                                            <tr>
                                                <td className="text-center">b.</td>
                                                <td>If not, whether any alternative arrangement for playground is provided within a radius of 5 kms along with bus facility</td>
                                                <td>
                                                    <input type="radio" name="alternativePlayground" value="Yes" checked={formik.values.alternativePlayground === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("alternativePlayground", e.target.value); }} disabled={isDisabled} /> Yes &nbsp;
                                                    <input type="radio" name="alternativePlayground" value="No" checked={formik.values.alternativePlayground === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("alternativePlayground", e.target.value); }} disabled={isDisabled} /> No
                                                    <ErrorMessage name="alternativePlayground" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="alternativeArrangementRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="alternativeArrangementRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}
                                        {formik.values.alternativePlayground === "Yes" && (
                                            <tr>
                                                <td className="text-center">c.</td>
                                                <td>Whether MoU for utilization of the alternative facility for playground is produced</td>
                                                <td>
                                                    <Field type="radio" name="playgroundMoU" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                                                    <Field type="radio" name="playgroundMoU" value="No" disabled={isDisabled} /> No
                                                    <ErrorMessage name="playgroundMoU" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="playgroundMouRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="playgroundMouRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </Table>

                                {/* <h5 className="text-success mb-3 mt-4">13.Playground</h5> */}
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "5%" }}>Sl. No.</th>
                                            <th style={{ width: "45%" }}>Particulars</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                            <th style={{ width: "30%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">13</td>
                                            <td>Whether valid fire safety certificate </td>
                                            <td>
                                                <input type="radio" name="parkingExemptedCases" value="Yes" checked={formik.values.parkingExemptedCases === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                                                <input type="radio" name="parkingExemptedCases" value="No" className="ms-2" checked={formik.values.parkingExemptedCases === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="parkingExemptedCases" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="parkingExemptedCasesRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="parkingExemptedCasesRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">14</td>
                                            <td>Latest affidavit for exempted cases is produced</td>
                                            <td>
                                                <input type="radio" name="latestAffidavit" value="Yes" checked={formik.values.latestAffidavit === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                                                <input type="radio" name="latestAffidavit" value="No" className="ms-2" checked={formik.values.latestAffidavit === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                                                <ErrorMessage name="latestAffidavit" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="latestAffidavitRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="latestAffidavitRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                {/* UG Programmes Details - Same as EoP */}
                                {getUgCourses.length > 0 && (
                                    <>
                                        <h5 className="text-success mb-3">Details of the UG programmes</h5>
                                        <Table bordered responsive>
                                            <thead className="table-primary text-center">
                                                <tr><th>Sl. No.</th><th>Type of the UG Programme</th><th>Total No. of programmes</th><th>Sanctioned Intake</th></tr>
                                            </thead>
                                            <tbody>
                                                {getUgCourses?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>{item.course_cat_name}</td>
                                                        <td className="text-center">{item.count}</td>
                                                        <td className="text-center">{item.sum}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </>
                                )}

                                {/* PG Programmes Details - Same as EoP */}
                                {Array.isArray(pgCourses) && pgCourses.length > 0 && (
                                    <>
                                        <h5 className="text-success mb-3">Details of the PG programmes</h5>
                                        <Table bordered responsive>
                                            <thead className="table-primary text-center">
                                                <tr><th>Sl. No.</th><th>Type of the PG Programme</th><th>Total No. of programmes</th><th>Sanctioned Intake</th></tr>
                                            </thead>
                                            <tbody>
                                                {/* {pgCourses?.map((item, index) => ( */}
                                                {Array.isArray(pgCourses) && pgCourses?.map((item, index) => (

                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>{item.course_cat_name}</td>
                                                        <td className="text-center">{item.count}</td>
                                                        <td className="text-center">{item.sum}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </>
                                )}

                                {/* Corpus Fund Section - Same as EoP */}
                                <h5 className="text-success mb-3">14.Corpus Fund</h5>
                                <table className="table table-bordered">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "5%" }}>Sl.No</th>
                                            <th style={{ width: "45%" }}>Particulars</th>
                                            <th style={{ width: "20%" }}>Action</th>
                                            <th style={{ width: "30%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>
                                                Whether the college was exempted from paying the Corpus Fund:
                                            </td>

                                            <td>
                                                <input
                                                    type="radio"
                                                    name="corpusFund"
                                                    value="Yes"
                                                    onChange={(e) => { formik.handleChange(e); clearDependentFields("corpusFund", e.target.value); }}
                                                    checked={formik.values.corpusFund === "Yes"}
                                                    disabled={isDisabled}
                                                />{" "}
                                                Yes

                                                <input
                                                    type="radio"
                                                    name="corpusFund"
                                                    value="No"
                                                    className="ms-3"
                                                    onChange={(e) => { formik.handleChange(e); clearDependentFields("corpusFund", e.target.value); }}
                                                    checked={formik.values.corpusFund === "No"}
                                                    disabled={isDisabled}
                                                />{" "}
                                                No
                                                <ErrorMessage name="corpusFund" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="corpusFundRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="corpusFundRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                        {formik.values.corpusFund === "Yes" && (
                                            <tr>
                                                <td className="text-center">b.</td>

                                                <td>
                                                    whether the rural/tribal area certificate issued by MRO is produced:
                                                </td>

                                                <td>
                                                    <input
                                                        type="radio"
                                                        name="certificateIssued"
                                                        value="Yes"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        checked={formik.values.certificateIssued === "Yes"}
                                                        disabled={isDisabled}
                                                    />{" "}
                                                    Yes

                                                    <input
                                                        type="radio"
                                                        name="certificateIssued"
                                                        value="No"
                                                        className="ms-3"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        checked={formik.values.certificateIssued === "No"}
                                                        disabled={isDisabled}
                                                    />{" "}
                                                    No

                                                    <ErrorMessage
                                                        name="certificateIssued"
                                                        component="div"
                                                        className="text-danger"
                                                    />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="certificateIssuedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="certificateIssuedRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>

                                {formik.values.corpusFund === "No" && (
                                    <>

                                        {/* For Degree Colleges established before 2021-22 - Using corpusFundInstall data */}
                                        {corpusFundInstall.length > 0 && (<>
                                            <h5 className="text-success mb-3">For Degree Colleges established before 2021-22</h5>
                                            <Table bordered responsive>
                                                <thead className="table-primary text-center">
                                                    <tr>
                                                        <th rowSpan={2}>Required Information</th>
                                                        <th colSpan={3}>Installments</th>
                                                    </tr>
                                                    <tr>
                                                        <th>First</th>
                                                        <th>Second</th>
                                                        <th>Third</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Amount</td>
                                                        <td>{firstInstallment.amount || "-"}</td>
                                                        <td>{secondInstallment.amount || "-"}</td>
                                                        <td>{thirdInstallment.amount || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Period (from - to)</td>
                                                        <td>{firstInstallment.from_date ? `${firstInstallment.from_date} - ${firstInstallment.to_date}` : "-"}</td>
                                                        <td>{secondInstallment.from_date ? `${secondInstallment.from_date} - ${secondInstallment.to_date}` : "-"}</td>
                                                        <td>{thirdInstallment.from_date ? `${thirdInstallment.from_date} - ${thirdInstallment.to_date}` : "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date of FDR</td>
                                                        <td>{firstInstallment.date_of_fdr || "-"}</td>
                                                        <td>{secondInstallment.date_of_fdr || "-"}</td>
                                                        <td>{thirdInstallment.date_of_fdr || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Name & address of the Issuing Bank</td>
                                                        <td>{firstInstallment.bank_address || "-"}</td>
                                                        <td>{secondInstallment.bank_address || "-"}</td>
                                                        <td>{thirdInstallment.bank_address || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IFSC CODE</td>
                                                        <td>{firstInstallment.ifsc || "-"}</td>
                                                        <td>{secondInstallment.ifsc || "-"}</td>
                                                        <td>{thirdInstallment.ifsc || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date of maturity</td>
                                                        <td>{firstInstallment.date_of_maturity || "-"}</td>
                                                        <td>{secondInstallment.date_of_maturity || "-"}</td>
                                                        <td>{thirdInstallment.date_of_maturity || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date of renewal</td>
                                                        <td>{firstInstallment.date_of_renewal || "-"}</td>
                                                        <td>{secondInstallment.date_of_renewal || "-"}</td>
                                                        <td>{thirdInstallment.date_of_renewal || "-"}</td>
                                                    </tr>
                                                </tbody>
                                            </Table></>)}

                                        {/* For Degree Colleges / programmes sanctioned after 2021-22 - Using ugCorpusFunds data */}
                                        {ugCorpusFunds.length > 0 && (<>
                                            <h5 className="text-success mb-3">For Degree Colleges / programmes sanctioned after 2021-22</h5>
                                            <Table bordered responsive>
                                                <thead className="table-primary text-center">
                                                    <tr>
                                                        <th>Sl. No.</th>
                                                        <th>Programme</th>
                                                        <th>Amount</th>
                                                        <th>Period (from - to)</th>
                                                        <th>FDR / Bank Guarantee No.</th>
                                                        <th>Date</th>
                                                        <th>Name & address of the Issuing Bank (with IFSC code)</th>
                                                        <th>Date of maturity</th>
                                                        <th>Date of renewal</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ugCorpusFunds?.map((item, index) => (
                                                        <tr key={item.sno || index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{item.course_name || "-"}</td>
                                                            <td>{item.amount || "-"}</td>
                                                            <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                                                            <td>{item.fdr_bank_number || "-"}</td>
                                                            <td>{item.corpus_date || "-"}</td>
                                                            <td>{item.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                                                            <td>{item.date_maturity || "-"}</td>
                                                            <td>{item.date_renewal || "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </>)}

                                        {/* For existing PG Programmes sanctioned before 2021-22 */}
                                        {getPGBEFORE.length > 0 && (
                                            <>
                                                <h5 className="text-success mb-3">For existing PG Programmes sanctioned before 2021-22</h5>
                                                <Table bordered responsive>
                                                    <thead className="table-primary text-center">
                                                        <tr>
                                                            <th>Sl. No.</th>
                                                            <th>Programme</th>
                                                            <th>Amount</th>
                                                            <th>Period (from - to)</th>
                                                            <th>FDR / Bank Guarantee No.</th>
                                                            <th>Date</th>
                                                            <th>Name & address of the Issuing Bank (with IFSC code)</th>
                                                            <th>Date of maturity</th>
                                                            <th>Date of renewal</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {getPGBEFORE.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="text-center">{index + 1}</td>

                                                                <td>{item.course_name || "-"}</td>
                                                                <td>{item.amount || "-"}</td>

                                                                <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>

                                                                <td>{item.fdr_bank_number || "-"}</td>
                                                                <td>{item.corpus_date || "-"}</td>

                                                                <td>{item.bank_address ? `${item.bank_address} (${item.ifsc || "-"})` : "-"}</td>

                                                                <td>{item.date_maturity || "-"}</td>
                                                                <td>{item.date_renewal || "-"}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </>
                                        )}

                                        {/* For existing PG Programmes sanctioned after 2021-22 - Using pgCorpusFunds data */}
                                        {pgCorpusFunds.length > 0 && (
                                            <>
                                                <h5 className="text-success mb-3">For existing PG Programmes sanctioned after 2021-22</h5>
                                                <Table bordered responsive>
                                                    <thead className="table-primary text-center">
                                                        <tr>
                                                            <th>Sl. No.</th>
                                                            <th>Programme</th>
                                                            <th>Amount</th>
                                                            <th>Period (from - to)</th>
                                                            <th>FDR / Bank Guarantee No.</th>
                                                            <th>Date</th>
                                                            <th>Name & address of the Issuing Bank (with IFSC code)</th>
                                                            <th>Date of maturity</th>
                                                            <th>Date of renewal</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pgCorpusFunds?.map((item, index) => (
                                                            <tr key={item.sno || index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td>{item.course_name || "-"}</td>
                                                                <td>{item.amount || "-"}</td>
                                                                <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                                                                <td>{item.fdr_bank_number || "-"}</td>
                                                                <td>{item.corpus_date || "-"}</td>
                                                                <td>{item.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                                                                <td>{item.date_maturity || "-"}</td>
                                                                <td>{item.date_renewal || "-"}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </>
                                        )}
                                    </>
                                )}

                                {/* Infrastructure & Academic Facilities Survey - Same as EoP but simplified */}
                                <h4 className="mb-3 text-success">15.Infrastructure & Academic Facilities Survey</h4>
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "45%" }}>Particulars</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                            <th style={{ width: "35%" }}>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="table-secondary"><td colSpan="3"><strong>20. Lab Equipment</strong></td></tr>
                                        <tr><td>a. Whether lab equipment provided for all the subjects</td>
                                            <td>
                                                <Field type="radio" name="infraLabEquipment" value="Yes" checked={formik.values.infraLabEquipment === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraLabEquipment", e.target.value); }} disabled={isDisabled} /> Yes
                                                <Field type="radio" name="infraLabEquipment" value="No" className="ms-2" checked={formik.values.infraLabEquipment === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraLabEquipment", e.target.value); }} disabled={isDisabled} /> No
                                                <ErrorMessage name="infraLabEquipment" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraLabEquipmentRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraLabEquipmentRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        {formik.values.infraLabEquipment === "No" && (
                                            <tr><td>b. mention the subjects that lack equipment</td>
                                                <td>
                                                    <Field type="text" name="infraLabLackEquipment" className="form-control" disabled={isDisabled} />
                                                    <ErrorMessage name="infraLabLackEquipment" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="infraLabLackEquipmentRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="infraLabLackEquipmentRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}

                                        <tr className="table-secondary"><td colSpan="3"><strong>21. Library</strong></td></tr>
                                        <tr><td>a. Whether library books are provided for all the subjects</td>
                                            <td>
                                                <Field type="radio" name="infraLibraryBooksProvided" value="Yes" checked={formik.values.infraLibraryBooksProvided === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraLibraryBooksProvided", e.target.value); }} disabled={isDisabled} /> Yes
                                                <Field type="radio" name="infraLibraryBooksProvided" value="No" className="ms-2" checked={formik.values.infraLibraryBooksProvided === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraLibraryBooksProvided", e.target.value); }} disabled={isDisabled} /> No
                                                <ErrorMessage name="infraLibraryBooksProvided" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraLibraryBooksProvidedRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraLibraryBooksProvidedRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        {formik.values.infraLibraryBooksProvided === "No" && (
                                            <tr><td>b.  mention the subjects that lack books</td>
                                                <td>
                                                    <Field type="text" name="infraLibraryLackBooks" className="form-control" disabled={isDisabled} />
                                                    <ErrorMessage name="infraLibraryLackBooks" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="infraLibraryLackBooksRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="infraLibraryLackBooksRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}

                                        <tr className="table-secondary"><td colSpan="3"><strong>22. Staff particulars</strong></td></tr>
                                        <tr><td>a. Whether adequate teaching and supporting staff are provided to run the colleges as per the University / UGC norms</td>
                                            <td>
                                                <Field type="radio" name="infraStaffRunClg" value="Yes" checked={formik.values.infraStaffRunClg === "Yes"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraStaffRunClg", e.target.value); }} disabled={isDisabled} /> Yes
                                                <Field type="radio" name="infraStaffRunClg" value="No" className="ms-2" checked={formik.values.infraStaffRunClg === "No"} onChange={(e) => { formik.handleChange(e); clearDependentFields("infraStaffRunClg", e.target.value); }} disabled={isDisabled} /> No
                                                <ErrorMessage name="infraStaffRunClg" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraStaffAdequateRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraStaffAdequateRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        {formik.values.infraStaffRunClg === "No" && (
                                            <tr><td>b. mention the deficiencies</td>
                                                <td>
                                                    <Field type="text" name="infraStaffDeficiencies" className="form-control" disabled={isDisabled} />
                                                    <ErrorMessage name="infraStaffDeficiencies" component="div" className="text-danger" />
                                                </td>
                                                <td>
                                                    <Field as="textarea" name="infraStaffDeficienciesRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                    <ErrorMessage name="infraStaffDeficienciesRemarks" component="div" className="text-danger" />
                                                </td>
                                            </tr>
                                        )}

                                        <tr><td>23. Whether scholarship details are provided as per Annexure -III of the application</td>
                                            <td>
                                                <div><label className="me-3"><input type="radio" name="infraStaffScholarshipDetails" value="Yes" checked={formik.values.infraStaffScholarshipDetails === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes</label>
                                                    <label><input type="radio" name="infraStaffScholarshipDetails" value="No" checked={formik.values.infraStaffScholarshipDetails === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No</label></div>
                                                <ErrorMessage name="infraStaffScholarshipDetails" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraScholarshipDetailsRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraScholarshipDetailsRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        <tr><td>24. Whether the college secured any University ranks in the last academic year</td>
                                            <td>
                                                <div className="d-flex gap-3"><label><input type="radio" name="infraStaffUniversityRanks" value="Yes" checked={formik.values.infraStaffUniversityRanks === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes</label>
                                                    <label><input type="radio" name="infraStaffUniversityRanks" value="No" checked={formik.values.infraStaffUniversityRanks === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No</label></div>
                                                <ErrorMessage name="infraStaffUniversityRanks" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraUniversityRanksRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraUniversityRanksRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        <tr><td>25. Whether the college conducted extension activities during the last academic year</td>
                                            <td>
                                                <div className="d-flex gap-3"><label><input type="radio" name="infraStaffConductedExtension" value="Yes" checked={formik.values.infraStaffConductedExtension === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes</label>
                                                    <label><input type="radio" name="infraStaffConductedExtension" value="No" checked={formik.values.infraStaffConductedExtension === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No</label></div>
                                                <ErrorMessage name="infraStaffConductedExtension" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraExtensionActivitiesRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraExtensionActivitiesRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>

                                        <tr><td>26. Whether the college has functional website</td>
                                            <td>
                                                <input type="radio" name="infraStaffFunctionalWebsite" value="Yes" checked={formik.values.infraStaffFunctionalWebsite === "Yes"} onChange={() => formik.setFieldValue("infraStaffFunctionalWebsite", "Yes")} disabled={isDisabled} /> Yes
                                                <input type="radio" name="infraStaffFunctionalWebsite" value="No" className="ms-2" checked={formik.values.infraStaffFunctionalWebsite === "No"} onChange={() => formik.setFieldValue("infraStaffFunctionalWebsite", "No")} disabled={isDisabled} /> No
                                                <ErrorMessage name="infraStaffFunctionalWebsite" component="div" className="text-danger" />
                                            </td>
                                            <td>
                                                <Field as="textarea" name="infraFunctionalWebsiteRemarks" className="form-control" rows="3" disabled={isDisabled} />
                                                <ErrorMessage name="infraFunctionalWebsiteRemarks" component="div" className="text-danger" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>

                                {secondPhaseInspForShifting && (
                                    <div className="mt-4">
                                        <h5 className="text-success mb-3">Physical Infrastructure Verification (Phase 2)</h5>
                                        <p className="text-danger mb-2">* All fields are mandatory</p>

                                        <Table bordered responsive>
                                            <thead className="table-primary text-center">
                                                <tr>
                                                    <th style={{ width: "5%" }}>S#</th>
                                                    <th style={{ width: "40%" }}>Infrastructure / Description</th>
                                                    <th style={{ width: "20%" }}>Yes/No</th>
                                                    <th style={{ width: "35%" }}>Upload Photograph (if Yes)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    { sNo: 1, name: "principalRoom", label: "Principal Room", multiple: false },
                                                    { sNo: 2, name: "officeRoom", label: "Office Room", multiple: false },
                                                    { sNo: 3, name: "staffRoom", label: "Staff Room", multiple: false },
                                                    { sNo: 4, name: "classrooms", label: "Classrooms (at least 2 or 3 photos)", multiple: true },
                                                    { sNo: 5, name: "laboratories", label: "All Laboratories", multiple: false },
                                                    { sNo: 6, name: "library", label: "Library", multiple: false },
                                                    { sNo: 7, name: "playGround", label: "Play Ground", multiple: false },
                                                    { sNo: 8, name: "parking", label: "Parking", multiple: false },
                                                    { sNo: 9, name: "toilets", label: "Toilets for Men & Women", multiple: false },
                                                    { sNo: 10, name: "fireSafety", label: "Fire Safety Equipment", multiple: false },
                                                    { sNo: 11, name: "videoUpload", label: "Video Upload", isVideo: true }
                                                ].map((item) => {
                                                    const infraValue = formik.values.infrastructure?.[item.name];
                                                    const selected = infraValue?.selected;

                                                    // ==================== CLASSROOMS (3 separate uploads) ====================
                                                    if (item.name === "classrooms") {
                                                        return (
                                                            <tr key={item.name}>
                                                                <td className="text-center">{item.sNo}</td>
                                                                <td>{item.label}</td>
                                                                <td>
                                                                    <label className="me-2">
                                                                        <Field
                                                                            type="radio"
                                                                            name={`infrastructure.${item.name}.selected`}
                                                                            value="yes"
                                                                            checked={formik.values.infrastructure?.[item.name]?.selected === "yes"}
                                                                            disabled={isDisabled}
                                                                        /> &nbsp;Yes
                                                                    </label>
                                                                    <label>
                                                                        <Field
                                                                            type="radio"
                                                                            name={`infrastructure.${item.name}.selected`}
                                                                            value="no"
                                                                            disabled={isDisabled}
                                                                            checked={formik.values.infrastructure?.[item.name]?.selected === "no"}
                                                                        /> &nbsp;No
                                                                    </label>
                                                                    {/* <ErrorMessage
                                                                        name={`infrastructure.${item.name}.selected`}
                                                                        component="div"
                                                                        className="text-danger small mt-1"
                                                                    /> */}
                                                                    {formik.errors.infrastructure?.[item.name]?.selected && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure[item.name].selected}
    </div>
)}
                                                                </td>
                                                                <td>
                                                                    {selected === "yes" && (
                                                                        <div>
                                                                            {/* Classroom 1 */}
                                                                            <div className="mb-3 p-2 border rounded">
                                                                                <label className="fw-bold">Classroom 1:</label>
                                                                                <div className="d-flex align-items-center gap-2 mt-1">
                                                                                    <input
                                                                                        type="file"
                                                                                        className="form-control form-control-sm"
                                                                                        accept="image/*,.pdf"
                                                                                        onChange={(e) => {
                                                                                            const path = "/Uploads/Infrastructure/";
                                                                                            ImagePdfBucket(e, formik, path, `infrastructure.${item.name}.classroom1.filePath`, `${item.name}_classroom1`, "image").then((uploadedPath) => {
                                                                                                formik.setFieldValue(`infrastructure.${item.name}.classroom1.filePath`, uploadedPath);
                                                                                                if (e.target.files[0]) {
                                                                                                    formik.setFieldValue(`infrastructure.${item.name}.classroom1.fileName`, e.target.files[0].name);
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        disabled={isDisabled}
                                                                                    />
                                                                                    {infraValue?.classroom1?.filePath && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                            onClick={() => viewImage(infraValue.classroom1.filePath)}
                                                                                        >
                                                                                            <i className="fa fa-eye"></i>
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                                {infraValue?.classroom1?.fileName && (
                                                                                    <div className="text-success small mt-1">✓ {infraValue.classroom1.fileName}</div>
                                                                                )}
                                                                                {/* <ErrorMessage
                                                                                    name={`infrastructure.${item.name}.classroom1.filePath`}
                                                                                    component="div"
                                                                                    className="text-danger small mt-1"
                                                                                /> */}
                                                                                {formik.errors.infrastructure?.classrooms?.classroom1?.filePath && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure.classrooms.classroom1.filePath}
    </div>
)}
                                                                            </div>

                                                                            {/* Classroom 2 */}
                                                                            <div className="mb-3 p-2 border rounded">
                                                                                <label className="fw-bold">Classroom 2:</label>
                                                                                <div className="d-flex align-items-center gap-2 mt-1">
                                                                                    <input
                                                                                        type="file"
                                                                                        className="form-control form-control-sm"
                                                                                        accept="image/*,.pdf"
                                                                                        onChange={(e) => {
                                                                                            const path = "/Uploads/Infrastructure/";
                                                                                            ImagePdfBucket(e, formik, path, `infrastructure.${item.name}.classroom2.filePath`, `${item.name}_classroom2`, "image").then((uploadedPath) => {
                                                                                                formik.setFieldValue(`infrastructure.${item.name}.classroom2.filePath`, uploadedPath);
                                                                                                if (e.target.files[0]) {
                                                                                                    formik.setFieldValue(`infrastructure.${item.name}.classroom2.fileName`, e.target.files[0].name);
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        disabled={isDisabled}
                                                                                    />
                                                                                    {infraValue?.classroom2?.filePath && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                            onClick={() => viewImage(infraValue.classroom2.filePath)}
                                                                                        >
                                                                                            <i className="fa fa-eye"></i>
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                                {infraValue?.classroom2?.fileName && (
                                                                                    <div className="text-success small mt-1">✓ {infraValue.classroom2.fileName}</div>
                                                                                )}
                                                                                {/* <ErrorMessage
                                                                                    name={`infrastructure.${item.name}.classroom2.filePath`}
                                                                                    component="div"
                                                                                    className="text-danger small mt-1"
                                                                                /> */}
                                                                                {formik.errors.infrastructure?.classrooms?.classroom2?.filePath && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure.classrooms.classroom2.filePath}
    </div>
)}
                                                                            </div>

                                                                            {/* Classroom 3 */}
                                                                            <div className="mb-3 p-2 border rounded">
                                                                                <label className="fw-bold">Classroom 3:</label>
                                                                                <div className="d-flex align-items-center gap-2 mt-1">
                                                                                    <input
                                                                                        type="file"
                                                                                        className="form-control form-control-sm"
                                                                                        accept="image/*,.pdf"
                                                                                        onChange={(e) => {
                                                                                            const path = "/Uploads/Infrastructure/";
                                                                                            ImagePdfBucket(e, formik, path, `infrastructure.${item.name}.classroom3.filePath`, `${item.name}_classroom3`, "image").then((uploadedPath) => {
                                                                                                formik.setFieldValue(`infrastructure.${item.name}.classroom3.filePath`, uploadedPath);
                                                                                                if (e.target.files[0]) {
                                                                                                    formik.setFieldValue(`infrastructure.${item.name}.classroom3.fileName`, e.target.files[0].name);
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        disabled={isDisabled}
                                                                                    />
                                                                                    {infraValue?.classroom3?.filePath && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                            onClick={() => viewImage(infraValue.classroom3.filePath)}
                                                                                        >
                                                                                            <i className="fa fa-eye"></i>
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                                {infraValue?.classroom3?.fileName && (
                                                                                    <div className="text-success small mt-1">✓ {infraValue.classroom3.fileName}</div>
                                                                                )}
                                                                                {/* <ErrorMessage
                                                                                    name={`infrastructure.${item.name}.classroom3.filePath`}
                                                                                    component="div"
                                                                                    className="text-danger small mt-1"
                                                                                /> */}
                                                                                {formik.errors.infrastructure?.classrooms?.classroom3?.filePath && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure.classrooms.classroom3.filePath}
    </div>
)}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {selected === "no" && (
                                                                        <span className="text-muted fst-italic">-</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    // ==================== VIDEO UPLOAD (no Yes/No) ====================
                                                    if (item.isVideo) {
                                                        return (
                                                            <tr key={item.name}>
                                                                <td className="text-center">{item.sNo}</td>
                                                                <td>{item.label}</td>
                                                                <td></td> {/* Empty cell for Yes/No column */}
                                                                <td>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <Field
                                                                            type="text"
                                                                            name={`infrastructure.${item.name}.videoUrl`}
                                                                            className="form-control"
                                                                            placeholder="Enter YouTube video URL"
                                                                            disabled={isDisabled}
                                                                        />
                                                                        {infraValue?.videoUrl && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => window.open(infraValue.videoUrl, '_blank')}
                                                                            >
                                                                                <i className="fa fa-play"></i> Watch
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    {/* <ErrorMessage
                                                                        name={`infrastructure.${item.name}.videoUrl`}
                                                                        component="div"
                                                                        className="text-danger small mt-1"
                                                                    /> */}
                                                                    {formik.errors.infrastructure?.[item.name]?.videoUrl && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure[item.name].videoUrl}
    </div>
)}
                                                                    <small className="text-muted d-block mt-1">
                                                                        Supported: YouTube links (youtu.be, youtube.com/watch)
                                                                    </small>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    // ==================== DEFAULT (Other items with Yes/No + file upload) ====================
                                                    return (
                                                        <tr key={item.name}>
                                                            <td className="text-center">{item.sNo}</td>
                                                            <td>{item.label}</td>
                                                            <td>
                                                                <label className="me-2">
                                                                    <Field
                                                                        type="radio"
                                                                        name={`infrastructure.${item.name}.selected`}
                                                                        checked={formik.values.infrastructure?.[item.name]?.selected === "yes"}

                                                                        value="yes"
                                                                        disabled={isDisabled}
                                                                    />&nbsp; Yes
                                                                </label>
                                                                <label>
                                                                    <Field
                                                                        type="radio"
                                                                        name={`infrastructure.${item.name}.selected`}
                                                                        value="no"
                                                                        checked={formik.values.infrastructure?.[item.name]?.selected === "no"}

                                                                        disabled={isDisabled}
                                                                    /> &nbsp; No
                                                                </label>
                                                                {/* <ErrorMessage
                                                                    name={`infrastructure.${item.name}.selected`}
                                                                    component="div"
                                                                    className="text-danger small mt-1"
                                                                /> */}
                                                                {formik.errors.infrastructure?.[item.name]?.selected && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure[item.name].selected}
    </div>
)}
                                                            </td>
                                                            <td>
                                                                {selected === "yes" && (
                                                                    <div>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="file"
                                                                                className="form-control form-control-sm"
                                                                                accept="image/*,.pdf"
                                                                                multiple={item.multiple}
                                                                                onChange={(e) => {
                                                                                    const path = "/Uploads/Infrastructure/";
                                                                                    ImagePdfBucket(e, formik, path, `infrastructure.${item.name}.filePath`, item.name, "image").then((uploadedPath) => {
                                                                                        formik.setFieldValue(`infrastructure.${item.name}.filePath`, uploadedPath);
                                                                                        if (e.target.files[0]) {
                                                                                            formik.setFieldValue(`infrastructure.${item.name}.fileName`, e.target.files[0].name);
                                                                                        }
                                                                                    });
                                                                                }}
                                                                                disabled={isDisabled}
                                                                            />
                                                                            {!item.multiple && infraValue?.filePath && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-outline-primary"
                                                                                    onClick={() => viewImage(infraValue.filePath)}
                                                                                >
                                                                                    <i className="fa fa-eye"></i>
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                        {item.multiple && (
                                                                            <small className="text-muted d-block mt-1">* You can select multiple photos</small>
                                                                        )}
                                                                        {item.multiple && infraValue?.filePaths?.length > 0 && (
                                                                            <div className="mt-2">
                                                                                <small className="text-success">✓ {infraValue.filePaths.length} file(s) uploaded</small>
                                                                                <div className="d-flex flex-wrap gap-1 mt-1">
                                                                                    {infraValue.filePaths?.map((path, idx) => (
                                                                                        <button key={idx} type="button" className="btn btn-sm btn-outline-secondary" onClick={() => viewImage(path)}>
                                                                                            <i className="fa fa-eye"></i> {idx + 1}
                                                                                        </button>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {!item.multiple && infraValue?.fileName && (
                                                                            <div className="text-success small mt-1">✓ {infraValue.fileName}</div>
                                                                        )}
                                                                        {/* <ErrorMessage
                                                                            name={`infrastructure.${item.name}.${item.multiple ? 'filePaths' : 'filePath'}`}
                                                                            component="div"
                                                                            className="text-danger small mt-1"
                                                                        /> */}
                                                                        {formik.errors.infrastructure?.[item.name]?.filePath && (
    <div className="text-danger small mt-1">
        {formik.errors.infrastructure[item.name].filePath}
    </div>
)}
                                                                    </div>
                                                                )}
                                                                {selected === "no" && (
                                                                    <span className="text-muted fst-italic">-</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}


                                {/* Final Remarks and Status - Same as EoP */}
                                <h5 className="mb-3">Final Remarks:</h5>
                                <textarea
                                    name="finalRemarks"
                                    className="form-control"
                                    rows="5"
                                    // style={{ resize: "vertical" }}  
                                    style={{
                                        height: "auto",       // ✅ allows rows to work
                                        resize: "vertical"    // ✅ shows drag icon
                                    }}
                                    placeholder="Enter final remarks..."
                                    value={formik.values.finalRemarks}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={isDisabled}
                                />
                                {/* <textarea name="finalRemarks" className="form-control" rows="4" placeholder="Enter final remarks..." value={formik.values.finalRemarks} onChange={formik.handleChange} onBlur={formik.handleBlur} disabled={isDisabled} /> */}
                                {formik.touched.finalRemarks && formik.errors.finalRemarks && <div className="text-danger">{formik.errors.finalRemarks}</div>}

                                <div className="mb-3">
                                    <h5>Final Status</h5>

                                    <div className="d-flex align-items-end gap-2 flex-wrap w-100">
                                        <select name="finalStatus" className="form-select form-select-m w-auto select-input" value={formik.values.finalStatus} onChange={(e) => { formik.handleChange(e); clearDependentFields("finalStatus", e.target.value); }} onBlur={formik.handleBlur} disabled={isDisabled} >
                                            <option value="">-- Select --</option>
                                            {finalStatusOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>

                                        {secondPhaseInspForShifting && !isDisabled && (
                                            <button
                                                type="button"
                                                className="btn btn-secondary ms-auto"
                                                onClick={handleSave}
                                            >
                                                Save
                                            </button>
                                        )}
                                    </div>

                                    {formik.touched.finalStatus && formik.errors.finalStatus && <div className="text-danger">{formik.errors.finalStatus}</div>}
                                </div>
                                {canShowSecondPhasePreview && (
                                    <div className="mb-3 border rounded p-3 bg-light">
                                        <h6 className="mb-2">Inspection Preview</h6>
                                        <p className="mb-2 text-muted">
                                            Open the preview, download the report, take signatures, and upload the signed PDF below.
                                        </p>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setShowInspectionPreviewModal(true)}
                                        >
                                            Open Inspection Preview
                                        </button>
                                    </div>
                                )}

                                {canShowSecondPhasePreview && (
                                    <div className="mb-4 border rounded p-3">
                                        <h6 className="mb-2">Signed Inspection Report Upload</h6>
                                        <small className="d-block mb-2 text-danger fw-semibold">
                                            Important: Download the Inspection Preview, get all required signatures on the report, and upload the signed PDF to proceed.
                                        </small>
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="flex-grow-1">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="application/pdf"
                                                    disabled={isDisabled}
                                                    onChange={(e) => {
                                                        ImagePdfBucket(e, formik, "/Uploads/grievupload/", "signedInspectionReport", "signedInspectionReport", "pdf");
                                                    }}
                                                />
                                            </div>
                                            {formik.values.signedInspectionReport?.trim() && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary d-flex align-items-center gap-1"
                                                    onClick={() => viewImage(formik.values.signedInspectionReport)}
                                                    title="View uploaded signed PDF"
                                                >
                                                    {/* <BsFileEarmarkPdfFill /> */}
                                                    <BsEyeFill />
                                                </button>
                                            )}
                                        </div>
                                        {formik.touched.signedInspectionReport && formik.errors.signedInspectionReport && (
                                            <div className="text-danger mt-1">{formik.errors.signedInspectionReport}</div>
                                        )}
                                    </div>
                                )}
                                {((formik.values.finalStatus === "DeficiencyIdentified" && !secondPhaseInspForShifting) ||
                                    (secondPhaseInspForShifting &&
                                        (formik.values.finalStatus === "May not be permitted" ||
                                            formik.values.finalStatus === "Conditionally Permitted"))) && (
                                        <div className="mt-3">
                                            <Table bordered responsive>
                                                <thead className="table-primary text-center">
                                                    <tr>
                                                        <th style={{ width: "10%" }}>S.No</th>
                                                        <th style={{ width: "70%" }}>Deficiency Identified</th>
                                                        <th style={{ width: "20%" }}>Action</th>
                                                    </tr>
                                                </thead>

                                                <FieldArray name="deficiencies">
                                                    {({ push, remove }) => {
                                                        const deficiencies = formik?.values?.deficiencies;
                                                        return (
                                                            <tbody>
                                                                {Array.isArray(deficiencies) &&
                                                                    deficiencies.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center fw-bold">{index + 1}</td>
                                                                            <td>
                                                                                <Field
                                                                                    as="textarea"
                                                                                    name={`deficiencies.${index}.remarks`}
                                                                                    className="form-control form-control-sm"
                                                                                    placeholder="Enter deficiency details..."
                                                                                    rows="2"
                                                                                    disabled={isDisabled}
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`deficiencies.${index}.remarks`}
                                                                                    component="small"
                                                                                    className="text-danger"
                                                                                />
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {deficiencies.length > 1 && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-danger p-0"
                                                                                        onClick={() => remove(index)}
                                                                                        disabled={isDisabled}
                                                                                    >
                                                                                        <BiTrash size={20} />
                                                                                    </button>
                                                                                )}
                                                                                {index === deficiencies.length - 1 && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-success p-0 ms-2"
                                                                                        onClick={() => push({ remarks: "" })}
                                                                                        disabled={isDisabled}
                                                                                    >
                                                                                        <VscDiffAdded size={20} /> Add
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        );
                                                    }}
                                                </FieldArray>
                                            </Table>
                                        </div>
                                    )}

                                <Modal show={showInspectionPreviewModal} onHide={() => setShowInspectionPreviewModal(false)} size="xl" scrollable>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Inspection Preview - {collCode || CllgCodeFromSession}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {/* <CollegeReport
                                            apiData={pdfData}
                                            apiData2={finalGet}
                                            rowData={apiValues}
                                            getOverallData={pdfData}
                                            getSurvey={getSurvey}
                                            newAddData={shiftAddr}
                                        /> */}
                                        <FirstLevelInspPreviewForShiftingPreview
                                            collCode={CllgCodeFromSession} nocType={"shifting"} name="phase2" />
                                    </Modal.Body>
                                </Modal>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Submit Button - Same as EoP */}
                {isDisabled ? (
                    <div className="d-flex justify-content-end mt-3 align-items-center">
                        <span className="text-success me-3">✅ Already Submitted</span>
                        {getDef.length > 0 && (<>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleDownloadPDF}
                            >
                                📄 Download Deficiencies PDF
                            </button>
                        </>)}
                    </div>
                ) : (
                    <div className="d-flex justify-content-end mt-3">
                        {!secondPhaseInspForShifting && (
                            <button type="button" className="btn btn-secondary me-2" onClick={handleSave}>
                                Save
                            </button>
                        )}
                        {(!secondPhaseInspForShifting || canShowSecondPhasePreview) && (
                            <button type="submit" className="btn btn-primary" onClick={() => handleFinalSubmit("submit")}>
                                Final Submit
                            </button>
                        )}
                    </div>
                )}
            </Form>
        </FormikProvider >
    );
}